const $7e291c172da4527f$export$f8bb2f9f4607ed91 = ".";
const $7e291c172da4527f$export$9cb8e7b38dc3cece = Symbol("target");
const $7e291c172da4527f$export$881b71df7abed909 = Symbol("unsubscribe");


function $62b9e4e9c78e635e$export$2191e61a810db5fc(value) {
    return value instanceof Date || value instanceof Set || value instanceof Map || value instanceof WeakSet || value instanceof WeakMap || ArrayBuffer.isView(value);
}
function $62b9e4e9c78e635e$export$281bb0ec97352a76(value) {
    return (typeof value === "object" ? value === null : typeof value !== "function") || value instanceof RegExp;
}



var $7bf8ec2f1e22e106$export$2e2bcd8739ae039 = Array.isArray;


function $668222ccaa68481f$export$2e2bcd8739ae039(value) {
    return typeof value === "symbol";
}


const $f91752e229fd69d9$var$path = {
    after: (path1, subPath)=>{
        if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(path1)) return path1.slice(subPath.length);
        if (subPath === "") return path1;
        return path1.slice(subPath.length + 1);
    },
    concat: (path2, key)=>{
        if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(path2)) {
            path2 = [
                ...path2
            ];
            if (key) path2.push(key);
            return path2;
        }
        if (key && key.toString !== undefined) {
            if (path2 !== "") path2 += (0, $7e291c172da4527f$export$f8bb2f9f4607ed91);
            if ((0, $668222ccaa68481f$export$2e2bcd8739ae039)(key)) return path2 + key.toString();
            return path2 + key;
        }
        return path2;
    },
    initial: (path3)=>{
        if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(path3)) return path3.slice(0, -1);
        if (path3 === "") return path3;
        const index = path3.lastIndexOf((0, $7e291c172da4527f$export$f8bb2f9f4607ed91));
        if (index === -1) return "";
        return path3.slice(0, index);
    },
    last: (path4)=>{
        if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(path4)) return path4[path4.length - 1] || "";
        if (path4 === "") return path4;
        const index = path4.lastIndexOf((0, $7e291c172da4527f$export$f8bb2f9f4607ed91));
        if (index === -1) return path4;
        return path4.slice(index + 1);
    },
    walk: (path5, callback)=>{
        if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(path5)) for (const key of path5)callback(key);
        else if (path5 !== "") {
            let position = 0;
            let index = path5.indexOf((0, $7e291c172da4527f$export$f8bb2f9f4607ed91));
            if (index === -1) callback(path5);
            else while(position < path5.length){
                if (index === -1) index = path5.length;
                callback(path5.slice(position, index));
                position = index + 1;
                index = path5.indexOf((0, $7e291c172da4527f$export$f8bb2f9f4607ed91), position);
            }
        }
    },
    get (object, path6) {
        this.walk(path6, (key)=>{
            if (object) object = object[key];
        });
        return object;
    }
};
var $f91752e229fd69d9$export$2e2bcd8739ae039 = $f91752e229fd69d9$var$path;



function $ec8fe538e41297a5$export$2e2bcd8739ae039(value) {
    return typeof value === "object" && typeof value.next === "function";
}



function $12ea6ec8908c03e4$export$2e2bcd8739ae039(iterator, target, thisArg, applyPath, prepareValue) {
    const originalNext = iterator.next;
    if (target.name === "entries") iterator.next = function() {
        const result = originalNext.call(this);
        if (result.done === false) {
            result.value[0] = prepareValue(result.value[0], target, result.value[0], applyPath);
            result.value[1] = prepareValue(result.value[1], target, result.value[0], applyPath);
        }
        return result;
    };
    else if (target.name === "values") {
        const keyIterator = thisArg[0, $7e291c172da4527f$export$9cb8e7b38dc3cece].keys();
        iterator.next = function() {
            const result = originalNext.call(this);
            if (result.done === false) result.value = prepareValue(result.value, target, keyIterator.next().value, applyPath);
            return result;
        };
    } else iterator.next = function() {
        const result = originalNext.call(this);
        if (result.done === false) result.value = prepareValue(result.value, target, result.value, applyPath);
        return result;
    };
    return iterator;
}



function $6c9ff15c0535cd26$export$2e2bcd8739ae039(cache, options, property) {
    return cache.isUnsubscribed || options.ignoreSymbols && (0, $668222ccaa68481f$export$2e2bcd8739ae039)(property) || options.ignoreUnderscores && property.charAt(0) === "_" || "ignoreKeys" in options && options.ignoreKeys.includes(property);
}



class $fe1fd95010e1effe$export$2e2bcd8739ae039 {
    _getDescriptorCache() {
        if (this._descriptorCache === undefined) this._descriptorCache = new WeakMap();
        return this._descriptorCache;
    }
    _getProperties(target) {
        const descriptorCache = this._getDescriptorCache();
        let properties = descriptorCache.get(target);
        if (properties === undefined) {
            properties = {};
            descriptorCache.set(target, properties);
        }
        return properties;
    }
    _getOwnPropertyDescriptor(target, property) {
        if (this.isUnsubscribed) return Reflect.getOwnPropertyDescriptor(target, property);
        const properties = this._getProperties(target);
        let descriptor = properties[property];
        if (descriptor === undefined) {
            descriptor = Reflect.getOwnPropertyDescriptor(target, property);
            properties[property] = descriptor;
        }
        return descriptor;
    }
    getProxy(target, path1, handler, proxyTarget) {
        if (this.isUnsubscribed) return target;
        const reflectTarget = target[proxyTarget];
        const source = reflectTarget || target;
        this._pathCache.set(source, path1);
        let proxy = this._proxyCache.get(source);
        if (proxy === undefined) {
            proxy = reflectTarget === undefined ? new Proxy(target, handler) : target;
            this._proxyCache.set(source, proxy);
        }
        return proxy;
    }
    getPath(target) {
        return this.isUnsubscribed ? undefined : this._pathCache.get(target);
    }
    isDetached(target, object) {
        return !Object.is(target, (0, $f91752e229fd69d9$export$2e2bcd8739ae039).get(object, this.getPath(target)));
    }
    defineProperty(target, property, descriptor) {
        if (!Reflect.defineProperty(target, property, descriptor)) return false;
        if (!this.isUnsubscribed) this._getProperties(target)[property] = descriptor;
        return true;
    }
    setProperty(target, property, value, receiver, previous) {
        if (!this._equals(previous, value) || !(property in target)) {
            const descriptor = this._getOwnPropertyDescriptor(target, property);
            if (descriptor !== undefined && "set" in descriptor) return Reflect.set(target, property, value, receiver);
            return Reflect.set(target, property, value);
        }
        return true;
    }
    deleteProperty(target, property, previous) {
        if (Reflect.deleteProperty(target, property)) {
            if (!this.isUnsubscribed) {
                const properties = this._getDescriptorCache().get(target);
                if (properties) {
                    delete properties[property];
                    this._pathCache.delete(previous);
                }
            }
            return true;
        }
        return false;
    }
    isSameDescriptor(a, target, property) {
        const b = this._getOwnPropertyDescriptor(target, property);
        return a !== undefined && b !== undefined && Object.is(a.value, b.value) && (a.writable || false) === (b.writable || false) && (a.enumerable || false) === (b.enumerable || false) && (a.configurable || false) === (b.configurable || false) && a.get === b.get && a.set === b.set;
    }
    isGetInvariant(target, property) {
        const descriptor = this._getOwnPropertyDescriptor(target, property);
        return descriptor !== undefined && descriptor.configurable !== true && descriptor.writable !== true;
    }
    unsubscribe() {
        this._descriptorCache = null;
        this._pathCache = null;
        this._proxyCache = null;
        this.isUnsubscribed = true;
    }
    constructor(equals){
        this._equals = equals;
        this._proxyCache = new WeakMap();
        this._pathCache = new WeakMap();
        this.isUnsubscribed = false;
    }
}




function $3340bc64d7ec7cdf$export$2e2bcd8739ae039(value) {
    return toString.call(value) === "[object Object]";
}





function $e0921caba6edf45c$export$2e2bcd8739ae039() {
    return true;
}


function $9b3eedb5f9e3cc76$export$2e2bcd8739ae039(clone, value) {
    return clone.length !== value.length || clone.some((item, index)=>value[index] !== item);
}


const $bbbce5e33f95c7ed$export$87ab45442debb687 = new Set([
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf", 
]);


const $9b5ee925cf31606b$var$IMMUTABLE_ARRAY_METHODS = new Set([
    "concat",
    "includes",
    "indexOf",
    "join",
    "keys",
    "lastIndexOf", 
]);
const $9b5ee925cf31606b$export$4e33e1ac2be38fa3 = {
    push: (0, $e0921caba6edf45c$export$2e2bcd8739ae039),
    pop: (0, $e0921caba6edf45c$export$2e2bcd8739ae039),
    shift: (0, $e0921caba6edf45c$export$2e2bcd8739ae039),
    unshift: (0, $e0921caba6edf45c$export$2e2bcd8739ae039),
    copyWithin: (0, $9b3eedb5f9e3cc76$export$2e2bcd8739ae039),
    reverse: (0, $9b3eedb5f9e3cc76$export$2e2bcd8739ae039),
    sort: (0, $9b3eedb5f9e3cc76$export$2e2bcd8739ae039),
    splice: (0, $9b3eedb5f9e3cc76$export$2e2bcd8739ae039),
    flat: (0, $9b3eedb5f9e3cc76$export$2e2bcd8739ae039),
    fill: (0, $9b3eedb5f9e3cc76$export$2e2bcd8739ae039)
};
const $9b5ee925cf31606b$export$157c4abf6d17869e = new Set([
    ...(0, $bbbce5e33f95c7ed$export$87ab45442debb687),
    ...$9b5ee925cf31606b$var$IMMUTABLE_ARRAY_METHODS,
    ...Object.keys($9b5ee925cf31606b$export$4e33e1ac2be38fa3), 
]);


function $5d92907737393f03$export$2e2bcd8739ae039(clone, value) {
    if (clone.size !== value.size) return true;
    for (const element of clone){
        if (!value.has(element)) return true;
    }
    return false;
}


const $8172dff6dcfccb32$export$fc33389dd13370bf = [
    "keys",
    "values",
    "entries", 
];
const $8172dff6dcfccb32$export$917446fc33e7cb53 = new Set([
    "has",
    "toString", 
]);
const $8172dff6dcfccb32$export$1b750ad9668ebc59 = {
    add: (0, $5d92907737393f03$export$2e2bcd8739ae039),
    clear: (0, $5d92907737393f03$export$2e2bcd8739ae039),
    delete: (0, $5d92907737393f03$export$2e2bcd8739ae039),
    forEach: (0, $5d92907737393f03$export$2e2bcd8739ae039)
};
const $8172dff6dcfccb32$export$31c36d107390313f = new Set([
    ...$8172dff6dcfccb32$export$917446fc33e7cb53,
    ...Object.keys($8172dff6dcfccb32$export$1b750ad9668ebc59),
    ...$8172dff6dcfccb32$export$fc33389dd13370bf, 
]);


function $c0d7177279319035$export$2e2bcd8739ae039(clone, value) {
    if (clone.size !== value.size) return true;
    let bValue;
    for (const [key, aValue] of clone){
        bValue = value.get(key);
        if (bValue !== aValue || bValue === undefined && !value.has(key)) return true;
    }
    return false;
}



const $c11ee12c803bdb6f$var$IMMUTABLE_MAP_METHODS = new Set([
    ...(0, $8172dff6dcfccb32$export$917446fc33e7cb53),
    "get"
]);
const $c11ee12c803bdb6f$export$5e358a2f59cad3d0 = {
    set: (0, $c0d7177279319035$export$2e2bcd8739ae039),
    clear: (0, $c0d7177279319035$export$2e2bcd8739ae039),
    delete: (0, $c0d7177279319035$export$2e2bcd8739ae039),
    forEach: (0, $c0d7177279319035$export$2e2bcd8739ae039)
};
const $c11ee12c803bdb6f$export$424149ce245f02b7 = new Set([
    ...$c11ee12c803bdb6f$var$IMMUTABLE_MAP_METHODS,
    ...Object.keys($c11ee12c803bdb6f$export$5e358a2f59cad3d0),
    ...(0, $8172dff6dcfccb32$export$fc33389dd13370bf), 
]);



class $46b2c54d44671067$export$2e2bcd8739ae039 {
    static isHandledMethod(name) {
        return (0, $bbbce5e33f95c7ed$export$87ab45442debb687).has(name);
    }
    _shallowClone(value) {
        let clone = value;
        if ((0, $3340bc64d7ec7cdf$export$2e2bcd8739ae039)(value)) clone = {
            ...value
        };
        else if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(value) || ArrayBuffer.isView(value)) clone = [
            ...value
        ];
        else if (value instanceof Date) clone = new Date(value);
        else if (value instanceof Set) clone = new Set([
            ...value
        ].map((item)=>this._shallowClone(item)));
        else if (value instanceof Map) {
            clone = new Map();
            for (const [key, item] of value.entries())clone.set(key, this._shallowClone(item));
        }
        this._clonedCache.add(clone);
        return clone;
    }
    preferredThisArg(isHandledMethod, name, thisArg, thisProxyTarget) {
        if (isHandledMethod) {
            if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(thisProxyTarget)) this._onIsChanged = (0, $9b5ee925cf31606b$export$4e33e1ac2be38fa3)[name];
            else if (thisProxyTarget instanceof Set) this._onIsChanged = (0, $8172dff6dcfccb32$export$1b750ad9668ebc59)[name];
            else if (thisProxyTarget instanceof Map) this._onIsChanged = (0, $c11ee12c803bdb6f$export$5e358a2f59cad3d0)[name];
            return thisProxyTarget;
        }
        return thisArg;
    }
    update(fullPath, property, value) {
        const changePath = (0, $f91752e229fd69d9$export$2e2bcd8739ae039).after(fullPath, this._path);
        if (property !== "length") {
            let object = this.clone;
            (0, $f91752e229fd69d9$export$2e2bcd8739ae039).walk(changePath, (key)=>{
                if (object && object[key]) {
                    if (!this._clonedCache.has(object[key])) object[key] = this._shallowClone(object[key]);
                    object = object[key];
                }
            });
            if (this._hasOnValidate) this._changes.push({
                path: changePath,
                property: property,
                previous: value
            });
            if (object && object[property]) object[property] = value;
        }
        this._isChanged = true;
    }
    undo(object) {
        let change;
        for(let index = this._changes.length - 1; index !== -1; index--){
            change = this._changes[index];
            (0, $f91752e229fd69d9$export$2e2bcd8739ae039).get(object, change.path)[change.property] = change.previous;
        }
    }
    isChanged(value) {
        return this._onIsChanged === undefined ? this._isChanged : this._onIsChanged(this.clone, value);
    }
    constructor(value, path1, argumentsList, hasOnValidate){
        this._path = path1;
        this._isChanged = false;
        this._clonedCache = new Set();
        this._hasOnValidate = hasOnValidate;
        this._changes = hasOnValidate ? [] : null;
        this.clone = path1 === undefined ? value : this._shallowClone(value);
    }
}




class $ca4a420d57d9cf09$export$2e2bcd8739ae039 extends (0, $46b2c54d44671067$export$2e2bcd8739ae039) {
    static isHandledMethod(name) {
        return (0, $9b5ee925cf31606b$export$157c4abf6d17869e).has(name);
    }
}



class $f1067eba7503fd66$export$2e2bcd8739ae039 extends (0, $46b2c54d44671067$export$2e2bcd8739ae039) {
    undo(object) {
        object.setTime(this.clone.getTime());
    }
    isChanged(value, equals) {
        return !equals(this.clone.valueOf(), value.valueOf());
    }
}




class $ac20bb1d58a9c336$export$2e2bcd8739ae039 extends (0, $46b2c54d44671067$export$2e2bcd8739ae039) {
    static isHandledMethod(name) {
        return (0, $8172dff6dcfccb32$export$31c36d107390313f).has(name);
    }
    undo(object) {
        for (const value of this.clone)object.add(value);
        for (const value1 of object)if (!this.clone.has(value1)) object.delete(value1);
    }
}




class $7371f98a8d67d7e9$export$2e2bcd8739ae039 extends (0, $46b2c54d44671067$export$2e2bcd8739ae039) {
    static isHandledMethod(name) {
        return (0, $c11ee12c803bdb6f$export$424149ce245f02b7).has(name);
    }
    undo(object) {
        for (const [key, value] of this.clone.entries())object.set(key, value);
        for (const key1 of object.keys())if (!this.clone.has(key1)) object.delete(key1);
    }
}



class $0894d65c1c99473e$export$2e2bcd8739ae039 extends (0, $46b2c54d44671067$export$2e2bcd8739ae039) {
    isChanged(value) {
        return this._weakValue !== value.has(this._arg1);
    }
    undo(object) {
        if (this._weakValue && !object.has(this._arg1)) object.add(this._arg1);
        else object.delete(this._arg1);
    }
    constructor(value, path, argumentsList, hasOnValidate){
        super(undefined, path, argumentsList, hasOnValidate);
        this._arg1 = argumentsList[0];
        this._weakValue = value.has(this._arg1);
    }
}



class $35ef612d96e3f5f5$export$2e2bcd8739ae039 extends (0, $46b2c54d44671067$export$2e2bcd8739ae039) {
    isChanged(value) {
        return this._weakValue !== value.get(this._weakKey);
    }
    undo(object) {
        const weakHas = object.has(this._weakKey);
        if (this._weakHas && !weakHas) object.set(this._weakKey, this._weakValue);
        else if (!this._weakHas && weakHas) object.delete(this._weakKey);
        else if (this._weakValue !== object.get(this._weakKey)) object.set(this._weakKey, this._weakValue);
    }
    constructor(value, path, argumentsList, hasOnValidate){
        super(undefined, path, argumentsList, hasOnValidate);
        this._weakKey = argumentsList[0];
        this._weakHas = value.has(this._weakKey);
        this._weakValue = value.get(this._weakKey);
    }
}


class $3608989449e8a0eb$export$2e2bcd8739ae039 {
    static isHandledType(value) {
        return (0, $3340bc64d7ec7cdf$export$2e2bcd8739ae039)(value) || (0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(value) || (0, $62b9e4e9c78e635e$export$2191e61a810db5fc)(value);
    }
    static isHandledMethod(target, name) {
        if ((0, $3340bc64d7ec7cdf$export$2e2bcd8739ae039)(target)) return (0, $46b2c54d44671067$export$2e2bcd8739ae039).isHandledMethod(name);
        if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(target)) return (0, $ca4a420d57d9cf09$export$2e2bcd8739ae039).isHandledMethod(name);
        if (target instanceof Set) return (0, $ac20bb1d58a9c336$export$2e2bcd8739ae039).isHandledMethod(name);
        if (target instanceof Map) return (0, $7371f98a8d67d7e9$export$2e2bcd8739ae039).isHandledMethod(name);
        return (0, $62b9e4e9c78e635e$export$2191e61a810db5fc)(target);
    }
    get isCloning() {
        return this._stack.length > 0;
    }
    start(value, path, argumentsList) {
        let CloneClass = (0, $46b2c54d44671067$export$2e2bcd8739ae039);
        if ((0, $7bf8ec2f1e22e106$export$2e2bcd8739ae039)(value)) CloneClass = (0, $ca4a420d57d9cf09$export$2e2bcd8739ae039);
        else if (value instanceof Date) CloneClass = (0, $f1067eba7503fd66$export$2e2bcd8739ae039);
        else if (value instanceof Set) CloneClass = (0, $ac20bb1d58a9c336$export$2e2bcd8739ae039);
        else if (value instanceof Map) CloneClass = (0, $7371f98a8d67d7e9$export$2e2bcd8739ae039);
        else if (value instanceof WeakSet) CloneClass = (0, $0894d65c1c99473e$export$2e2bcd8739ae039);
        else if (value instanceof WeakMap) CloneClass = (0, $35ef612d96e3f5f5$export$2e2bcd8739ae039);
        this._stack.push(new CloneClass(value, path, argumentsList, this._hasOnValidate));
    }
    update(fullPath, property, value) {
        this._stack[this._stack.length - 1].update(fullPath, property, value);
    }
    preferredThisArg(target, thisArg, thisProxyTarget) {
        const { name: name  } = target;
        const isHandledMethod = $3608989449e8a0eb$export$2e2bcd8739ae039.isHandledMethod(thisProxyTarget, name);
        return this._stack[this._stack.length - 1].preferredThisArg(isHandledMethod, name, thisArg, thisProxyTarget);
    }
    isChanged(isMutable, value, equals) {
        return this._stack[this._stack.length - 1].isChanged(isMutable, value, equals);
    }
    undo(object) {
        if (this._previousClone !== undefined) this._previousClone.undo(object);
    }
    stop() {
        this._previousClone = this._stack.pop();
        return this._previousClone.clone;
    }
    constructor(hasOnValidate){
        this._stack = [];
        this._hasOnValidate = hasOnValidate;
    }
}


const $69e9f2982bc0ecad$var$defaultOptions = {
    equals: Object.is,
    isShallow: false,
    pathAsArray: false,
    ignoreSymbols: false,
    ignoreUnderscores: false,
    ignoreDetached: false,
    details: false
};
const $69e9f2982bc0ecad$var$onChange = (object, onChange1, options = {})=>{
    options = {
        ...$69e9f2982bc0ecad$var$defaultOptions,
        ...options
    };
    const proxyTarget = Symbol("ProxyTarget");
    const { equals: equals , isShallow: isShallow , ignoreDetached: ignoreDetached , details: details  } = options;
    const cache = new (0, $fe1fd95010e1effe$export$2e2bcd8739ae039)(equals);
    const hasOnValidate = typeof options.onValidate === "function";
    const smartClone = new (0, $3608989449e8a0eb$export$2e2bcd8739ae039)(hasOnValidate);
    // eslint-disable-next-line max-params
    const validate = (target, property, value, previous, applyData)=>!hasOnValidate || smartClone.isCloning || options.onValidate((0, $f91752e229fd69d9$export$2e2bcd8739ae039).concat(cache.getPath(target), property), value, previous, applyData) === true;
    const handleChangeOnTarget = (target, property, value, previous)=>{
        if (!(0, $6c9ff15c0535cd26$export$2e2bcd8739ae039)(cache, options, property) && !(ignoreDetached && cache.isDetached(target, object))) handleChange(cache.getPath(target), property, value, previous);
    };
    // eslint-disable-next-line max-params
    const handleChange = (changePath, property, value, previous, applyData)=>{
        if (smartClone.isCloning) smartClone.update(changePath, property, previous);
        else onChange1((0, $f91752e229fd69d9$export$2e2bcd8739ae039).concat(changePath, property), value, previous, applyData);
    };
    const getProxyTarget = (value)=>value ? value[proxyTarget] || value : value;
    const prepareValue = (value, target, property, basePath)=>{
        if ((0, $62b9e4e9c78e635e$export$281bb0ec97352a76)(value) || property === "constructor" || isShallow && !(0, $3608989449e8a0eb$export$2e2bcd8739ae039).isHandledMethod(target, property) || (0, $6c9ff15c0535cd26$export$2e2bcd8739ae039)(cache, options, property) || cache.isGetInvariant(target, property) || ignoreDetached && cache.isDetached(target, object)) return value;
        if (basePath === undefined) basePath = cache.getPath(target);
        return cache.getProxy(value, (0, $f91752e229fd69d9$export$2e2bcd8739ae039).concat(basePath, property), handler, proxyTarget);
    };
    const handler = {
        get (target, property, receiver) {
            if ((0, $668222ccaa68481f$export$2e2bcd8739ae039)(property)) {
                if (property === proxyTarget || property === (0, $7e291c172da4527f$export$9cb8e7b38dc3cece)) return target;
                if (property === (0, $7e291c172da4527f$export$881b71df7abed909) && !cache.isUnsubscribed && cache.getPath(target).length === 0) {
                    cache.unsubscribe();
                    return target;
                }
            }
            const value = (0, $62b9e4e9c78e635e$export$2191e61a810db5fc)(target) ? Reflect.get(target, property) : Reflect.get(target, property, receiver);
            return prepareValue(value, target, property);
        },
        set (target, property, value, receiver) {
            value = getProxyTarget(value);
            const reflectTarget = target[proxyTarget] || target;
            const previous = reflectTarget[property];
            if (equals(previous, value) && property in target) return true;
            const isValid = validate(target, property, value, previous);
            if (isValid && cache.setProperty(reflectTarget, property, value, receiver, previous)) {
                handleChangeOnTarget(target, property, target[property], previous);
                return true;
            }
            return !isValid;
        },
        defineProperty (target, property, descriptor) {
            if (!cache.isSameDescriptor(descriptor, target, property)) {
                const previous = target[property];
                if (validate(target, property, descriptor.value, previous) && cache.defineProperty(target, property, descriptor, previous)) handleChangeOnTarget(target, property, descriptor.value, previous);
            }
            return true;
        },
        deleteProperty (target, property) {
            if (!Reflect.has(target, property)) return true;
            const previous = Reflect.get(target, property);
            const isValid = validate(target, property, undefined, previous);
            if (isValid && cache.deleteProperty(target, property, previous)) {
                handleChangeOnTarget(target, property, undefined, previous);
                return true;
            }
            return !isValid;
        },
        apply (target, thisArg, argumentsList) {
            const thisProxyTarget = thisArg[proxyTarget] || thisArg;
            if (cache.isUnsubscribed) return Reflect.apply(target, thisProxyTarget, argumentsList);
            if ((details === false || details !== true && !details.includes(target.name)) && (0, $3608989449e8a0eb$export$2e2bcd8739ae039).isHandledType(thisProxyTarget)) {
                let applyPath = (0, $f91752e229fd69d9$export$2e2bcd8739ae039).initial(cache.getPath(target));
                const isHandledMethod = (0, $3608989449e8a0eb$export$2e2bcd8739ae039).isHandledMethod(thisProxyTarget, target.name);
                smartClone.start(thisProxyTarget, applyPath, argumentsList);
                let result = Reflect.apply(target, smartClone.preferredThisArg(target, thisArg, thisProxyTarget), isHandledMethod ? argumentsList.map((argument)=>getProxyTarget(argument)) : argumentsList);
                const isChanged = smartClone.isChanged(thisProxyTarget, equals);
                const previous = smartClone.stop();
                if ((0, $3608989449e8a0eb$export$2e2bcd8739ae039).isHandledType(result) && isHandledMethod) {
                    if (thisArg instanceof Map && target.name === "get") applyPath = (0, $f91752e229fd69d9$export$2e2bcd8739ae039).concat(applyPath, argumentsList[0]);
                    result = cache.getProxy(result, applyPath, handler);
                }
                if (isChanged) {
                    const applyData = {
                        name: target.name,
                        args: argumentsList,
                        result: result
                    };
                    const changePath = smartClone.isCloning ? (0, $f91752e229fd69d9$export$2e2bcd8739ae039).initial(applyPath) : applyPath;
                    const property = smartClone.isCloning ? (0, $f91752e229fd69d9$export$2e2bcd8739ae039).last(applyPath) : "";
                    if (validate((0, $f91752e229fd69d9$export$2e2bcd8739ae039).get(object, changePath), property, thisProxyTarget, previous, applyData)) handleChange(changePath, property, thisProxyTarget, previous, applyData);
                    else smartClone.undo(thisProxyTarget);
                }
                if ((thisArg instanceof Map || thisArg instanceof Set) && (0, $ec8fe538e41297a5$export$2e2bcd8739ae039)(result)) return (0, $12ea6ec8908c03e4$export$2e2bcd8739ae039)(result, target, thisArg, applyPath, prepareValue);
                return result;
            }
            return Reflect.apply(target, thisArg, argumentsList);
        }
    };
    const proxy = cache.getProxy(object, options.pathAsArray ? [] : "", handler);
    onChange1 = onChange1.bind(proxy);
    if (hasOnValidate) options.onValidate = options.onValidate.bind(proxy);
    return proxy;
};
$69e9f2982bc0ecad$var$onChange.target = (proxy)=>proxy && proxy[0, $7e291c172da4527f$export$9cb8e7b38dc3cece] || proxy;
$69e9f2982bc0ecad$var$onChange.unsubscribe = (proxy)=>proxy[0, $7e291c172da4527f$export$881b71df7abed909] || proxy;
var $69e9f2982bc0ecad$export$2e2bcd8739ae039 = $69e9f2982bc0ecad$var$onChange;


// Set format for results
const $d51973068a97db52$var$setFormatNumber = (dataFormat)=>+Math.round(dataFormat);
// PMI rate -- (PMI-Ипотечное страхование)
const $d51973068a97db52$var$getPmiResult = (excludeValue, mortgageAmount, pmiRate)=>{
    if (!excludeValue) {
        const result = mortgageAmount * pmiRate / 12;
        return $d51973068a97db52$var$setFormatNumber(result);
    }
    return 0;
};
// Property tax function
const $d51973068a97db52$var$propertyTaxCalc = (excludeValue, propertyTax)=>{
    if (!excludeValue) {
        const result = propertyTax / 12;
        return $d51973068a97db52$var$setFormatNumber(result);
    }
    return 0;
};
// Home insurance function
const $d51973068a97db52$var$homeInsuranceCalc = (excludeValue, homeInsurance)=>{
    if (!excludeValue) {
        const result = homeInsurance / 12;
        return $d51973068a97db52$var$setFormatNumber(result);
    }
    return 0;
};
// Monthly function
const $d51973068a97db52$var$monthlyPaymentCalc = (mortgageAmount, interestRateResult, paymentsMonths, pmiResult, hoaAmount, propertyTaxResult, homeInsuranceResult)=>{
    if (interestRateResult !== 0) {
        const result = mortgageAmount * interestRateResult * (1 + interestRateResult) ** paymentsMonths / ((1 + interestRateResult) ** paymentsMonths - 1) + pmiResult + hoaAmount + propertyTaxResult + homeInsuranceResult;
        return $d51973068a97db52$var$setFormatNumber(result);
    }
    return 0;
};
// Monthly PI function
const $d51973068a97db52$var$monthlyPICalc = (mortgageAmount, interestRateResult, paymentsMonths)=>{
    const result = mortgageAmount * interestRateResult * (1 + interestRateResult) ** paymentsMonths / ((1 + interestRateResult) ** paymentsMonths - 1);
    return $d51973068a97db52$var$setFormatNumber(result);
};
// Total cost function
const $d51973068a97db52$var$totalCostAmountCalc = (monthlyPaymentResult, paymentsMonths)=>{
    const result = monthlyPaymentResult * paymentsMonths;
    return $d51973068a97db52$var$setFormatNumber(result);
};
const $d51973068a97db52$var$calc = (elements, watchedState)=>{
    const { form: form , result: result , donutData: donutData  } = watchedState;
    const { values: values , exclude: exclude  } = form;
    const homePrice = values["home-price"];
    const downPayment = values["down-payment"];
    const interestRate = values["interest-rate"];
    const homeInsurance = values["home-insurance"];
    const propertyTax = values["property-tax"];
    const pmiRate = values["pmi-rate"];
    const hoaAmount = values["hoa-dues"];
    const { term: term  } = values;
    const monthInYear = 12;
    const percentBase = 100;
    const mortgageAmount = $d51973068a97db52$var$setFormatNumber(homePrice - downPayment); // основной кредит, основная сумма
    const paymentsMonths = term * monthInYear; // количество месяцев
    const interestRateResult = interestRate / percentBase / monthInYear; // процентная ставка по еж.платежу
    const pmiResult = $d51973068a97db52$var$getPmiResult(exclude["pmi-rate"], mortgageAmount, pmiRate);
    const homeInsuranceResult = $d51973068a97db52$var$homeInsuranceCalc(exclude["property-tax"], homeInsurance);
    const propertyTaxResult = $d51973068a97db52$var$propertyTaxCalc(exclude["property-tax"], propertyTax);
    const monthlyPaymentResult = $d51973068a97db52$var$monthlyPaymentCalc(mortgageAmount, interestRateResult, paymentsMonths, pmiResult, hoaAmount, propertyTaxResult, homeInsuranceResult);
    const monthlyPIResult = $d51973068a97db52$var$monthlyPICalc(mortgageAmount, interestRateResult, paymentsMonths);
    const totalCostAmountResult = $d51973068a97db52$var$totalCostAmountCalc(monthlyPaymentResult, paymentsMonths);
    // * RESULTS
    // calcMortgageAmount - сумма ипотеки
    result["mortgage-amount"] = mortgageAmount;
    // calcMonthlyPayment - ежемесячный платеж
    result["monthly-payment"] = monthlyPaymentResult;
    // calcTotalCost - общая сумма выплат
    result["mortgage-insurance"] = pmiResult;
    // Total Cost Of Mortgage
    result["mortgage-total-cost"] = totalCostAmountResult;
    // donut data list
    donutData.forEach(({ key: key  }, index)=>{
        switch(key){
            case "pi":
                donutData[index].data = monthlyPIResult;
                break;
            case "insurance":
                donutData[index].data = homeInsuranceResult;
                break;
            case "taxes":
                donutData[index].data = propertyTaxResult;
                break;
            case "pmi":
                donutData[index].data = pmiResult;
                break;
            case "hoa":
                donutData[index].data = hoaAmount;
                break;
            default:
                break;
        }
    });
};
var $d51973068a97db52$export$2e2bcd8739ae039 = $d51973068a97db52$var$calc;


/*!
 * Chart.js v3.8.0
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $f0bf98aa79b5dc9b$export$9d0e2d13d04f7070(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
const $f0bf98aa79b5dc9b$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback1) {
        return callback1();
    };
    return window.requestAnimationFrame;
}();
function $f0bf98aa79b5dc9b$export$b4171a6734a65d42(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args1 = [];
    return function(...rest) {
        args1 = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $f0bf98aa79b5dc9b$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args1);
            });
        }
    };
}
function $f0bf98aa79b5dc9b$export$2219238a014317b0(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $f0bf98aa79b5dc9b$export$34aec0b863436764 = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $f0bf98aa79b5dc9b$export$3c2fa207a37baaea = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $f0bf98aa79b5dc9b$export$91c6e00c14e7e6fd = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $f0bf98aa79b5dc9b$export$890c4ad488842ce7() {}
const $f0bf98aa79b5dc9b$export$555508cbc6add439 = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $f0bf98aa79b5dc9b$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
function $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
function $f0bf98aa79b5dc9b$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $f0bf98aa79b5dc9b$export$39b482c5e57630a8 = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $f0bf98aa79b5dc9b$export$c4ce752e73470fba(value, defaultValue) {
    return $f0bf98aa79b5dc9b$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $f0bf98aa79b5dc9b$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $f0bf98aa79b5dc9b$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $f0bf98aa79b5dc9b$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $f0bf98aa79b5dc9b$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($f0bf98aa79b5dc9b$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $f0bf98aa79b5dc9b$export$ee7c8ad385a60b7b(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $f0bf98aa79b5dc9b$export$c03999cb2f36933f(source) {
    if ($f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(source)) return source.map($f0bf98aa79b5dc9b$export$c03999cb2f36933f);
    if ($f0bf98aa79b5dc9b$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $f0bf98aa79b5dc9b$export$c03999cb2f36933f(source[keys[k]]);
        return target;
    }
    return source;
}
function $f0bf98aa79b5dc9b$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $f0bf98aa79b5dc9b$export$2ed0fc6709e59212(key, target, source, options) {
    if (!$f0bf98aa79b5dc9b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($f0bf98aa79b5dc9b$export$23f2a1d2818174ef(tval) && $f0bf98aa79b5dc9b$export$23f2a1d2818174ef(sval)) $f0bf98aa79b5dc9b$export$6559d589eb85fbb6(tval, sval, options);
    else target[key] = $f0bf98aa79b5dc9b$export$c03999cb2f36933f(sval);
}
function $f0bf98aa79b5dc9b$export$6559d589eb85fbb6(target, source, options) {
    const sources = $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$f0bf98aa79b5dc9b$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $f0bf98aa79b5dc9b$export$2ed0fc6709e59212;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$f0bf98aa79b5dc9b$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $f0bf98aa79b5dc9b$export$7910e0436ed8d1de(target, source) {
    return $f0bf98aa79b5dc9b$export$6559d589eb85fbb6(target, source, {
        merger: $f0bf98aa79b5dc9b$export$f96d196f7728bb5
    });
}
function $f0bf98aa79b5dc9b$export$f96d196f7728bb5(key, target, source) {
    if (!$f0bf98aa79b5dc9b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($f0bf98aa79b5dc9b$export$23f2a1d2818174ef(tval) && $f0bf98aa79b5dc9b$export$23f2a1d2818174ef(sval)) $f0bf98aa79b5dc9b$export$7910e0436ed8d1de(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $f0bf98aa79b5dc9b$export$c03999cb2f36933f(sval);
}
function $f0bf98aa79b5dc9b$export$738ab4df8bf92ae9(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $f0bf98aa79b5dc9b$var$emptyString = "";
const $f0bf98aa79b5dc9b$var$dot = ".";
function $f0bf98aa79b5dc9b$var$indexOfDotOrLength(key, start) {
    const idx = key.indexOf($f0bf98aa79b5dc9b$var$dot, start);
    return idx === -1 ? key.length : idx;
}
function $f0bf98aa79b5dc9b$export$2d1720544b23b823(obj, key) {
    if (key === $f0bf98aa79b5dc9b$var$emptyString) return obj;
    let pos = 0;
    let idx = $f0bf98aa79b5dc9b$var$indexOfDotOrLength(key, pos);
    while(obj && idx > pos){
        obj = obj[key.slice(pos, idx)];
        pos = idx + 1;
        idx = $f0bf98aa79b5dc9b$var$indexOfDotOrLength(key, pos);
    }
    return obj;
}
function $f0bf98aa79b5dc9b$export$efca4cbe5dd06740(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $f0bf98aa79b5dc9b$export$35e795649ee09318 = (value)=>typeof value !== "undefined";
const $f0bf98aa79b5dc9b$export$2e2af4578d910ddf = (value)=>typeof value === "function";
const $f0bf98aa79b5dc9b$export$c9170ad7d4cd7e57 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $f0bf98aa79b5dc9b$export$995eb9fca571757(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const $f0bf98aa79b5dc9b$export$56c0d5a1e737357d = Math.PI;
const $f0bf98aa79b5dc9b$export$971d5caa766a69d7 = 2 * $f0bf98aa79b5dc9b$export$56c0d5a1e737357d;
const $f0bf98aa79b5dc9b$export$e171bab687b50e0 = $f0bf98aa79b5dc9b$export$971d5caa766a69d7 + $f0bf98aa79b5dc9b$export$56c0d5a1e737357d;
const $f0bf98aa79b5dc9b$export$527e9aa3390079e9 = Number.POSITIVE_INFINITY;
const $f0bf98aa79b5dc9b$export$a17c37559e1db147 = $f0bf98aa79b5dc9b$export$56c0d5a1e737357d / 180;
const $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd = $f0bf98aa79b5dc9b$export$56c0d5a1e737357d / 2;
const $f0bf98aa79b5dc9b$export$fef3dfd9bad05307 = $f0bf98aa79b5dc9b$export$56c0d5a1e737357d / 4;
const $f0bf98aa79b5dc9b$export$8c78c7c36408ea29 = $f0bf98aa79b5dc9b$export$56c0d5a1e737357d * 2 / 3;
const $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e = Math.log10;
const $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5 = Math.sign;
function $f0bf98aa79b5dc9b$export$cf2f7c5792f80b46(range) {
    const roundedRange = Math.round(range);
    range = $f0bf98aa79b5dc9b$export$a33b77bbdbb8366c(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $f0bf98aa79b5dc9b$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $f0bf98aa79b5dc9b$export$9e5f44173e64f162(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $f0bf98aa79b5dc9b$export$a33b77bbdbb8366c(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $f0bf98aa79b5dc9b$export$53a70dd1ebbae346(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $f0bf98aa79b5dc9b$export$158acd800e1ef08b(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $f0bf98aa79b5dc9b$export$625550452a3fa3ec(degrees) {
    return degrees * ($f0bf98aa79b5dc9b$export$56c0d5a1e737357d / 180);
}
function $f0bf98aa79b5dc9b$export$25ce5a424b770e84(radians) {
    return radians * (180 / $f0bf98aa79b5dc9b$export$56c0d5a1e737357d);
}
function $f0bf98aa79b5dc9b$export$b9a6b53f9be3734(x) {
    if (!$f0bf98aa79b5dc9b$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $f0bf98aa79b5dc9b$export$e7094788287c5e9b(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $f0bf98aa79b5dc9b$export$56c0d5a1e737357d) angle += $f0bf98aa79b5dc9b$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $f0bf98aa79b5dc9b$export$24baa2b76016ce0e(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $f0bf98aa79b5dc9b$export$d29e374196577086(a, b) {
    return (a - b + $f0bf98aa79b5dc9b$export$e171bab687b50e0) % $f0bf98aa79b5dc9b$export$971d5caa766a69d7 - $f0bf98aa79b5dc9b$export$56c0d5a1e737357d;
}
function $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(a) {
    return (a % $f0bf98aa79b5dc9b$export$971d5caa766a69d7 + $f0bf98aa79b5dc9b$export$971d5caa766a69d7) % $f0bf98aa79b5dc9b$export$971d5caa766a69d7;
}
function $f0bf98aa79b5dc9b$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(angle);
    const s = $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(start);
    const e = $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(end);
    const angleToStart = $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(s - a);
    const angleToEnd = $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(e - a);
    const startToAngle = $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(a - s);
    const endToAngle = $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $f0bf98aa79b5dc9b$export$e7c866399fa523f5(value) {
    return $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b(value, -32768, 32767);
}
function $f0bf98aa79b5dc9b$export$f38c853ae54ed474(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
const $f0bf98aa79b5dc9b$var$atEdge = (t)=>t === 0 || t === 1;
const $f0bf98aa79b5dc9b$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $f0bf98aa79b5dc9b$export$971d5caa766a69d7 / p));
const $f0bf98aa79b5dc9b$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $f0bf98aa79b5dc9b$export$971d5caa766a69d7 / p) + 1;
const $f0bf98aa79b5dc9b$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($f0bf98aa79b5dc9b$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$f0bf98aa79b5dc9b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$f0bf98aa79b5dc9b$var$atEdge(t) ? t : $f0bf98aa79b5dc9b$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$f0bf98aa79b5dc9b$var$atEdge(t) ? t : $f0bf98aa79b5dc9b$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $f0bf98aa79b5dc9b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $f0bf98aa79b5dc9b$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $f0bf98aa79b5dc9b$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $f0bf98aa79b5dc9b$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $f0bf98aa79b5dc9b$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $f0bf98aa79b5dc9b$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $f0bf98aa79b5dc9b$var$round(v) {
    return v + 0.5 | 0;
}
const $f0bf98aa79b5dc9b$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $f0bf98aa79b5dc9b$var$p2b(v) {
    return $f0bf98aa79b5dc9b$var$lim($f0bf98aa79b5dc9b$var$round(v * 2.55), 0, 255);
}
function $f0bf98aa79b5dc9b$var$n2b(v) {
    return $f0bf98aa79b5dc9b$var$lim($f0bf98aa79b5dc9b$var$round(v * 255), 0, 255);
}
function $f0bf98aa79b5dc9b$var$b2n(v) {
    return $f0bf98aa79b5dc9b$var$lim($f0bf98aa79b5dc9b$var$round(v / 2.55) / 100, 0, 1);
}
function $f0bf98aa79b5dc9b$var$n2p(v) {
    return $f0bf98aa79b5dc9b$var$lim($f0bf98aa79b5dc9b$var$round(v * 100), 0, 100);
}
const $f0bf98aa79b5dc9b$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $f0bf98aa79b5dc9b$var$hex = [
    ..."0123456789ABCDEF"
];
const $f0bf98aa79b5dc9b$var$h1 = (b)=>$f0bf98aa79b5dc9b$var$hex[b & 0xF];
const $f0bf98aa79b5dc9b$var$h2 = (b)=>$f0bf98aa79b5dc9b$var$hex[(b & 0xF0) >> 4] + $f0bf98aa79b5dc9b$var$hex[b & 0xF];
const $f0bf98aa79b5dc9b$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $f0bf98aa79b5dc9b$var$isShort = (v)=>$f0bf98aa79b5dc9b$var$eq(v.r) && $f0bf98aa79b5dc9b$var$eq(v.g) && $f0bf98aa79b5dc9b$var$eq(v.b) && $f0bf98aa79b5dc9b$var$eq(v.a);
function $f0bf98aa79b5dc9b$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $f0bf98aa79b5dc9b$var$map$1[str[1]] * 17,
            g: 255 & $f0bf98aa79b5dc9b$var$map$1[str[2]] * 17,
            b: 255 & $f0bf98aa79b5dc9b$var$map$1[str[3]] * 17,
            a: len === 5 ? $f0bf98aa79b5dc9b$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $f0bf98aa79b5dc9b$var$map$1[str[1]] << 4 | $f0bf98aa79b5dc9b$var$map$1[str[2]],
            g: $f0bf98aa79b5dc9b$var$map$1[str[3]] << 4 | $f0bf98aa79b5dc9b$var$map$1[str[4]],
            b: $f0bf98aa79b5dc9b$var$map$1[str[5]] << 4 | $f0bf98aa79b5dc9b$var$map$1[str[6]],
            a: len === 9 ? $f0bf98aa79b5dc9b$var$map$1[str[7]] << 4 | $f0bf98aa79b5dc9b$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $f0bf98aa79b5dc9b$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $f0bf98aa79b5dc9b$var$hexString(v) {
    var f = $f0bf98aa79b5dc9b$var$isShort(v) ? $f0bf98aa79b5dc9b$var$h1 : $f0bf98aa79b5dc9b$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $f0bf98aa79b5dc9b$var$alpha(v.a, f) : undefined;
}
const $f0bf98aa79b5dc9b$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f0bf98aa79b5dc9b$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $f0bf98aa79b5dc9b$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $f0bf98aa79b5dc9b$var$hwb2rgbn(h, w, b) {
    const rgb = $f0bf98aa79b5dc9b$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $f0bf98aa79b5dc9b$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $f0bf98aa79b5dc9b$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $f0bf98aa79b5dc9b$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $f0bf98aa79b5dc9b$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($f0bf98aa79b5dc9b$var$n2b);
}
function $f0bf98aa79b5dc9b$var$hsl2rgb(h, s, l) {
    return $f0bf98aa79b5dc9b$var$calln($f0bf98aa79b5dc9b$var$hsl2rgbn, h, s, l);
}
function $f0bf98aa79b5dc9b$var$hwb2rgb(h, w, b) {
    return $f0bf98aa79b5dc9b$var$calln($f0bf98aa79b5dc9b$var$hwb2rgbn, h, w, b);
}
function $f0bf98aa79b5dc9b$var$hsv2rgb(h, s, v) {
    return $f0bf98aa79b5dc9b$var$calln($f0bf98aa79b5dc9b$var$hsv2rgbn, h, s, v);
}
function $f0bf98aa79b5dc9b$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $f0bf98aa79b5dc9b$var$hueParse(str) {
    const m = $f0bf98aa79b5dc9b$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $f0bf98aa79b5dc9b$var$p2b(+m[5]) : $f0bf98aa79b5dc9b$var$n2b(+m[5]);
    const h = $f0bf98aa79b5dc9b$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $f0bf98aa79b5dc9b$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $f0bf98aa79b5dc9b$var$hsv2rgb(h, p1, p2);
    else v = $f0bf98aa79b5dc9b$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $f0bf98aa79b5dc9b$var$rotate(v, deg) {
    var h = $f0bf98aa79b5dc9b$var$rgb2hsl(v);
    h[0] = $f0bf98aa79b5dc9b$var$hue(h[0] + deg);
    h = $f0bf98aa79b5dc9b$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $f0bf98aa79b5dc9b$var$hslString(v) {
    if (!v) return;
    const a = $f0bf98aa79b5dc9b$var$rgb2hsl(v);
    const h = a[0];
    const s = $f0bf98aa79b5dc9b$var$n2p(a[1]);
    const l = $f0bf98aa79b5dc9b$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$f0bf98aa79b5dc9b$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $f0bf98aa79b5dc9b$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $f0bf98aa79b5dc9b$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $f0bf98aa79b5dc9b$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($f0bf98aa79b5dc9b$var$names$1);
    const tkeys = Object.keys($f0bf98aa79b5dc9b$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $f0bf98aa79b5dc9b$var$map[k]);
        }
        k = parseInt($f0bf98aa79b5dc9b$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $f0bf98aa79b5dc9b$var$names;
function $f0bf98aa79b5dc9b$var$nameParse(str) {
    if (!$f0bf98aa79b5dc9b$var$names) {
        $f0bf98aa79b5dc9b$var$names = $f0bf98aa79b5dc9b$var$unpack();
        $f0bf98aa79b5dc9b$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $f0bf98aa79b5dc9b$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $f0bf98aa79b5dc9b$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f0bf98aa79b5dc9b$var$rgbParse(str) {
    const m = $f0bf98aa79b5dc9b$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $f0bf98aa79b5dc9b$var$p2b(v) : $f0bf98aa79b5dc9b$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $f0bf98aa79b5dc9b$var$p2b(r) : $f0bf98aa79b5dc9b$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $f0bf98aa79b5dc9b$var$p2b(g) : $f0bf98aa79b5dc9b$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $f0bf98aa79b5dc9b$var$p2b(b) : $f0bf98aa79b5dc9b$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $f0bf98aa79b5dc9b$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$f0bf98aa79b5dc9b$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $f0bf98aa79b5dc9b$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $f0bf98aa79b5dc9b$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $f0bf98aa79b5dc9b$var$interpolate(rgb1, rgb2, t) {
    const r = $f0bf98aa79b5dc9b$var$from($f0bf98aa79b5dc9b$var$b2n(rgb1.r));
    const g = $f0bf98aa79b5dc9b$var$from($f0bf98aa79b5dc9b$var$b2n(rgb1.g));
    const b = $f0bf98aa79b5dc9b$var$from($f0bf98aa79b5dc9b$var$b2n(rgb1.b));
    return {
        r: $f0bf98aa79b5dc9b$var$n2b($f0bf98aa79b5dc9b$var$to(r + t * ($f0bf98aa79b5dc9b$var$from($f0bf98aa79b5dc9b$var$b2n(rgb2.r)) - r))),
        g: $f0bf98aa79b5dc9b$var$n2b($f0bf98aa79b5dc9b$var$to(g + t * ($f0bf98aa79b5dc9b$var$from($f0bf98aa79b5dc9b$var$b2n(rgb2.g)) - g))),
        b: $f0bf98aa79b5dc9b$var$n2b($f0bf98aa79b5dc9b$var$to(b + t * ($f0bf98aa79b5dc9b$var$from($f0bf98aa79b5dc9b$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $f0bf98aa79b5dc9b$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $f0bf98aa79b5dc9b$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $f0bf98aa79b5dc9b$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $f0bf98aa79b5dc9b$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $f0bf98aa79b5dc9b$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $f0bf98aa79b5dc9b$var$n2b(input[3]);
        }
    } else {
        v = $f0bf98aa79b5dc9b$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $f0bf98aa79b5dc9b$var$n2b(v.a);
    }
    return v;
}
function $f0bf98aa79b5dc9b$var$functionParse(str) {
    if (str.charAt(0) === "r") return $f0bf98aa79b5dc9b$var$rgbParse(str);
    return $f0bf98aa79b5dc9b$var$hueParse(str);
}
class $f0bf98aa79b5dc9b$var$Color {
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $f0bf98aa79b5dc9b$var$clone(this._rgb);
        if (v) v.a = $f0bf98aa79b5dc9b$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $f0bf98aa79b5dc9b$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $f0bf98aa79b5dc9b$var$rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $f0bf98aa79b5dc9b$var$hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $f0bf98aa79b5dc9b$var$hslString(this._rgb) : undefined;
    }
    mix(color1, weight) {
        if (color1) {
            const c1 = this.rgb;
            const c2 = color1.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color2, t) {
        if (color2) this._rgb = $f0bf98aa79b5dc9b$var$interpolate(this._rgb, color2._rgb, t);
        return this;
    }
    clone() {
        return new $f0bf98aa79b5dc9b$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $f0bf98aa79b5dc9b$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $f0bf98aa79b5dc9b$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $f0bf98aa79b5dc9b$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $f0bf98aa79b5dc9b$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $f0bf98aa79b5dc9b$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $f0bf98aa79b5dc9b$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $f0bf98aa79b5dc9b$var$rotate(this._rgb, deg);
        return this;
    }
    constructor(input){
        if (input instanceof $f0bf98aa79b5dc9b$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $f0bf98aa79b5dc9b$var$fromObject(input);
        else if (type === "string") v = $f0bf98aa79b5dc9b$var$hexParse(input) || $f0bf98aa79b5dc9b$var$nameParse(input) || $f0bf98aa79b5dc9b$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
}
function $f0bf98aa79b5dc9b$var$index_esm(input) {
    return new $f0bf98aa79b5dc9b$var$Color(input);
}
function $f0bf98aa79b5dc9b$export$9f4f30ee63539e24(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $f0bf98aa79b5dc9b$export$db3b6bfb95261072(value) {
    return $f0bf98aa79b5dc9b$export$9f4f30ee63539e24(value) ? value : $f0bf98aa79b5dc9b$var$index_esm(value);
}
function $f0bf98aa79b5dc9b$export$faec65b429be379(value) {
    return $f0bf98aa79b5dc9b$export$9f4f30ee63539e24(value) ? value : $f0bf98aa79b5dc9b$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $f0bf98aa79b5dc9b$export$ce26c07117d59d6a = Object.create(null);
const $f0bf98aa79b5dc9b$export$a8550f7dbe79f93a = Object.create(null);
function $f0bf98aa79b5dc9b$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $f0bf98aa79b5dc9b$var$set(root, scope, values) {
    if (typeof scope === "string") return $f0bf98aa79b5dc9b$export$6559d589eb85fbb6($f0bf98aa79b5dc9b$var$getScope$1(root, scope), values);
    return $f0bf98aa79b5dc9b$export$6559d589eb85fbb6($f0bf98aa79b5dc9b$var$getScope$1(root, ""), scope);
}
class $f0bf98aa79b5dc9b$var$Defaults {
    set(scope, values) {
        return $f0bf98aa79b5dc9b$var$set(this, scope, values);
    }
    get(scope) {
        return $f0bf98aa79b5dc9b$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $f0bf98aa79b5dc9b$var$set($f0bf98aa79b5dc9b$export$a8550f7dbe79f93a, scope, values);
    }
    override(scope, values) {
        return $f0bf98aa79b5dc9b$var$set($f0bf98aa79b5dc9b$export$ce26c07117d59d6a, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $f0bf98aa79b5dc9b$var$getScope$1(this, scope);
        const targetScopeObject = $f0bf98aa79b5dc9b$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($f0bf98aa79b5dc9b$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $f0bf98aa79b5dc9b$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    constructor(_descriptors1){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$f0bf98aa79b5dc9b$export$faec65b429be379(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$f0bf98aa79b5dc9b$export$faec65b429be379(options.borderColor);
        this.hoverColor = (ctx, options)=>$f0bf98aa79b5dc9b$export$faec65b429be379(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors1);
    }
}
var $f0bf98aa79b5dc9b$export$4368d992c4eafac0 = new $f0bf98aa79b5dc9b$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $f0bf98aa79b5dc9b$export$d377dcb2b61d6c4e(font) {
    if (!font || $f0bf98aa79b5dc9b$export$342063e11d6c3cad(font.size) || $f0bf98aa79b5dc9b$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $f0bf98aa79b5dc9b$export$3a6d5c9ae78a2c08(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $f0bf98aa79b5dc9b$export$a05254e7c3aeba6e(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(thing) !== true) longest = $f0bf98aa79b5dc9b$export$3a6d5c9ae78a2c08(ctx, data, gc, longest, thing);
        else if ($f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(nestedThing)) longest = $f0bf98aa79b5dc9b$export$3a6d5c9ae78a2c08(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $f0bf98aa79b5dc9b$export$71cec2538cb2c617(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $f0bf98aa79b5dc9b$export$f787f51d84a910ad(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $f0bf98aa79b5dc9b$export$6554612db691658e(ctx, options, x, y) {
    let type, xOffset, yOffset, size, cornerRadius;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $f0bf98aa79b5dc9b$export$a17c37559e1db147;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            ctx.arc(x, y, radius, 0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $f0bf98aa79b5dc9b$export$8c78c7c36408ea29;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $f0bf98aa79b5dc9b$export$8c78c7c36408ea29;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $f0bf98aa79b5dc9b$export$fef3dfd9bad05307) * size;
            yOffset = Math.sin(rad + $f0bf98aa79b5dc9b$export$fef3dfd9bad05307) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $f0bf98aa79b5dc9b$export$56c0d5a1e737357d, rad - $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd, rad + $f0bf98aa79b5dc9b$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                ctx.rect(x - size, y - size, 2 * size, 2 * size);
                break;
            }
            rad += $f0bf98aa79b5dc9b$export$fef3dfd9bad05307;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $f0bf98aa79b5dc9b$export$fef3dfd9bad05307;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $f0bf98aa79b5dc9b$export$fef3dfd9bad05307;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $f0bf98aa79b5dc9b$export$ef35774e6d314e91(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $f0bf98aa79b5dc9b$export$78acf4525d8a74c4(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $f0bf98aa79b5dc9b$export$dc98b0b04f4c7758(ctx) {
    ctx.restore();
}
function $f0bf98aa79b5dc9b$export$8a5498727ef6be21(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $f0bf98aa79b5dc9b$export$d24c54395ce0c509(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $f0bf98aa79b5dc9b$export$8743009a87fcb00f(ctx, text, x, y, font, opts = {}) {
    const lines = $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $f0bf98aa79b5dc9b$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$f0bf98aa79b5dc9b$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $f0bf98aa79b5dc9b$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $f0bf98aa79b5dc9b$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$f0bf98aa79b5dc9b$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $f0bf98aa79b5dc9b$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $f0bf98aa79b5dc9b$export$493d36ec626b6698(ctx, rect) {
    const { x: x , y: y , w: w , h: h , radius: radius  } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $f0bf98aa79b5dc9b$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $f0bf98aa79b5dc9b$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $f0bf98aa79b5dc9b$export$1a8f5705751d8277(value, size) {
    const matches = ("" + value).match($f0bf98aa79b5dc9b$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $f0bf98aa79b5dc9b$var$numberOrZero = (v)=>+v || 0;
function $f0bf98aa79b5dc9b$export$3b513254972cfc9c(value, props) {
    const ret = {};
    const objProps = $f0bf98aa79b5dc9b$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $f0bf98aa79b5dc9b$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$f0bf98aa79b5dc9b$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop1 of keys)ret[prop1] = $f0bf98aa79b5dc9b$var$numberOrZero(read(prop1));
    return ret;
}
function $f0bf98aa79b5dc9b$export$1fbe638ecf81657e(value) {
    return $f0bf98aa79b5dc9b$export$3b513254972cfc9c(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd(value) {
    return $f0bf98aa79b5dc9b$export$3b513254972cfc9c(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $f0bf98aa79b5dc9b$export$96f57966bedc81b4(value) {
    const obj = $f0bf98aa79b5dc9b$export$1fbe638ecf81657e(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9(options, fallback) {
    options = options || {};
    fallback = fallback || $f0bf98aa79b5dc9b$export$4368d992c4eafac0.font;
    let size = $f0bf98aa79b5dc9b$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $f0bf98aa79b5dc9b$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($f0bf98aa79b5dc9b$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $f0bf98aa79b5dc9b$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $f0bf98aa79b5dc9b$export$1a8f5705751d8277($f0bf98aa79b5dc9b$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $f0bf98aa79b5dc9b$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $f0bf98aa79b5dc9b$export$d377dcb2b61d6c4e(font);
    return font;
}
function $f0bf98aa79b5dc9b$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $f0bf98aa79b5dc9b$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min , max: max  } = minmax;
    const change = $f0bf98aa79b5dc9b$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $f0bf98aa79b5dc9b$export$91477dc880baac21(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $f0bf98aa79b5dc9b$export$d141bba7fdc215a3 = (table, key, value)=>$f0bf98aa79b5dc9b$export$91477dc880baac21(table, value, (index)=>table[index][key] < value);
const $f0bf98aa79b5dc9b$export$ebd11618f299a286 = (table, key, value)=>$f0bf98aa79b5dc9b$export$91477dc880baac21(table, value, (index)=>table[index][key] >= value);
function $f0bf98aa79b5dc9b$export$23ebac1979863676(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $f0bf98aa79b5dc9b$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $f0bf98aa79b5dc9b$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $f0bf98aa79b5dc9b$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $f0bf98aa79b5dc9b$export$efca4cbe5dd06740(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $f0bf98aa79b5dc9b$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $f0bf98aa79b5dc9b$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $f0bf98aa79b5dc9b$export$71511d61b312f219(items) {
    const set1 = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set1.add(items[i]);
    if (set1.size === ilen) return items;
    return Array.from(set1);
}
function $f0bf98aa79b5dc9b$export$c3950d9923825c02(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$f0bf98aa79b5dc9b$export$35e795649ee09318(fallback)) fallback = $f0bf98aa79b5dc9b$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$f0bf98aa79b5dc9b$export$c3950d9923825c02([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $f0bf98aa79b5dc9b$var$_cached(target, prop, ()=>$f0bf98aa79b5dc9b$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $f0bf98aa79b5dc9b$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $f0bf98aa79b5dc9b$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $f0bf98aa79b5dc9b$export$a93c5207d687da10(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $f0bf98aa79b5dc9b$export$a9c996f45e5784d0(proxy, descriptorDefaults),
        setContext: (ctx)=>$f0bf98aa79b5dc9b$export$a93c5207d687da10(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$f0bf98aa79b5dc9b$export$a93c5207d687da10(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $f0bf98aa79b5dc9b$var$_cached(target, prop, ()=>$f0bf98aa79b5dc9b$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $f0bf98aa79b5dc9b$export$a9c996f45e5784d0(proxy, defaults1 = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults1.scriptable , _indexable: _indexable = defaults1.indexable , _allKeys: _allKeys = defaults1.allKeys  } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $f0bf98aa79b5dc9b$export$2e2af4578d910ddf(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $f0bf98aa79b5dc9b$export$2e2af4578d910ddf(_indexable) ? _indexable : ()=>_indexable
    };
}
const $f0bf98aa79b5dc9b$var$readKey = (prefix, name)=>prefix ? prefix + $f0bf98aa79b5dc9b$export$efca4cbe5dd06740(name) : name;
const $f0bf98aa79b5dc9b$var$needsSubResolver = (prop, value)=>$f0bf98aa79b5dc9b$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $f0bf98aa79b5dc9b$var$_cached(target, prop, resolve1) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve1();
    target[prop] = value;
    return value;
}
function $f0bf98aa79b5dc9b$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy , _context: _context , _subProxy: _subProxy , _descriptors: descriptors1  } = target;
    let value = _proxy[prop];
    if ($f0bf98aa79b5dc9b$export$2e2af4578d910ddf(value) && descriptors1.isScriptable(prop)) value = $f0bf98aa79b5dc9b$var$_resolveScriptable(prop, value, target, receiver);
    if ($f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(value) && value.length) value = $f0bf98aa79b5dc9b$var$_resolveArray(prop, value, target, descriptors1.isIndexable);
    if ($f0bf98aa79b5dc9b$var$needsSubResolver(prop, value)) value = $f0bf98aa79b5dc9b$export$a93c5207d687da10(value, _context, _subProxy && _subProxy[prop], descriptors1);
    return value;
}
function $f0bf98aa79b5dc9b$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy , _context: _context , _subProxy: _subProxy , _stack: _stack  } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($f0bf98aa79b5dc9b$var$needsSubResolver(prop, value)) value = $f0bf98aa79b5dc9b$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $f0bf98aa79b5dc9b$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy , _context: _context , _subProxy: _subProxy , _descriptors: descriptors2  } = target;
    if ($f0bf98aa79b5dc9b$export$35e795649ee09318(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($f0bf98aa79b5dc9b$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $f0bf98aa79b5dc9b$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($f0bf98aa79b5dc9b$export$a93c5207d687da10(resolver, _context, _subProxy && _subProxy[prop], descriptors2));
        }
    }
    return value;
}
function $f0bf98aa79b5dc9b$var$resolveFallback(fallback, prop, value) {
    return $f0bf98aa79b5dc9b$export$2e2af4578d910ddf(fallback) ? fallback(prop, value) : fallback;
}
const $f0bf98aa79b5dc9b$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $f0bf98aa79b5dc9b$export$2d1720544b23b823(parent, key) : undefined;
function $f0bf98aa79b5dc9b$var$addScopes(set2, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $f0bf98aa79b5dc9b$var$getScope(key, parent);
        if (scope) {
            set2.add(scope);
            const fallback = $f0bf98aa79b5dc9b$var$resolveFallback(scope._fallback, key, value);
            if ($f0bf98aa79b5dc9b$export$35e795649ee09318(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $f0bf98aa79b5dc9b$export$35e795649ee09318(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $f0bf98aa79b5dc9b$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $f0bf98aa79b5dc9b$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set3 = new Set();
    set3.add(value);
    let key = $f0bf98aa79b5dc9b$var$addScopesFromKey(set3, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($f0bf98aa79b5dc9b$export$35e795649ee09318(fallback) && fallback !== prop) {
        key = $f0bf98aa79b5dc9b$var$addScopesFromKey(set3, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $f0bf98aa79b5dc9b$export$c3950d9923825c02(Array.from(set3), [
        ""
    ], rootScopes, fallback, ()=>$f0bf98aa79b5dc9b$var$subGetTarget(resolver, prop, value));
}
function $f0bf98aa79b5dc9b$var$addScopesFromKey(set4, allScopes, key, fallback, item) {
    while(key)key = $f0bf98aa79b5dc9b$var$addScopes(set4, allScopes, key, fallback, item);
    return key;
}
function $f0bf98aa79b5dc9b$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($f0bf98aa79b5dc9b$export$8b22cf2602fb60ce(target) && $f0bf98aa79b5dc9b$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $f0bf98aa79b5dc9b$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $f0bf98aa79b5dc9b$var$_resolve($f0bf98aa79b5dc9b$var$readKey(prefix, prop), scopes);
        if ($f0bf98aa79b5dc9b$export$35e795649ee09318(value)) return $f0bf98aa79b5dc9b$var$needsSubResolver(prop, value) ? $f0bf98aa79b5dc9b$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $f0bf98aa79b5dc9b$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($f0bf98aa79b5dc9b$export$35e795649ee09318(value)) return value;
    }
}
function $f0bf98aa79b5dc9b$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $f0bf98aa79b5dc9b$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $f0bf98aa79b5dc9b$var$resolveKeysFromAllScopes(scopes) {
    const set5 = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set5.add(key);
    return Array.from(set5);
}
function $f0bf98aa79b5dc9b$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale  } = meta;
    const { key: key = "r"  } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($f0bf98aa79b5dc9b$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $f0bf98aa79b5dc9b$var$EPSILON = Number.EPSILON || 1e-14;
const $f0bf98aa79b5dc9b$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $f0bf98aa79b5dc9b$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $f0bf98aa79b5dc9b$export$667d3bf0c5f83305(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $f0bf98aa79b5dc9b$export$24baa2b76016ce0e(current, previous);
    const d12 = $f0bf98aa79b5dc9b$export$24baa2b76016ce0e(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $f0bf98aa79b5dc9b$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $f0bf98aa79b5dc9b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $f0bf98aa79b5dc9b$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($f0bf98aa79b5dc9b$export$a33b77bbdbb8366c(deltaK[i], 0, $f0bf98aa79b5dc9b$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $f0bf98aa79b5dc9b$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $f0bf98aa79b5dc9b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $f0bf98aa79b5dc9b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $f0bf98aa79b5dc9b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $f0bf98aa79b5dc9b$export$317a3d46287192d8(points, indexAxis = "x") {
    const valueAxis = $f0bf98aa79b5dc9b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $f0bf98aa79b5dc9b$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $f0bf98aa79b5dc9b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $f0bf98aa79b5dc9b$var$monotoneAdjust(points, deltaK, mK);
    $f0bf98aa79b5dc9b$var$monotoneCompute(points, mK, indexAxis);
}
function $f0bf98aa79b5dc9b$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $f0bf98aa79b5dc9b$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $f0bf98aa79b5dc9b$export$ef35774e6d314e91(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $f0bf98aa79b5dc9b$export$ef35774e6d314e91(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $f0bf98aa79b5dc9b$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $f0bf98aa79b5dc9b$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $f0bf98aa79b5dc9b$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $f0bf98aa79b5dc9b$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $f0bf98aa79b5dc9b$export$21579262ef46735b(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $f0bf98aa79b5dc9b$export$317a3d46287192d8(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $f0bf98aa79b5dc9b$export$667d3bf0c5f83305(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $f0bf98aa79b5dc9b$var$capBezierPoints(points, area);
}
function $f0bf98aa79b5dc9b$export$61196ced6d74a310() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $f0bf98aa79b5dc9b$export$2329c99376c9d0a4(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $f0bf98aa79b5dc9b$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $f0bf98aa79b5dc9b$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $f0bf98aa79b5dc9b$export$1ee57be6f6687d2c(el, property) {
    return $f0bf98aa79b5dc9b$var$getComputedStyle(el).getPropertyValue(property);
}
const $f0bf98aa79b5dc9b$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $f0bf98aa79b5dc9b$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $f0bf98aa79b5dc9b$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $f0bf98aa79b5dc9b$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $f0bf98aa79b5dc9b$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX , offsetY: offsetY  } = source;
    let box = false;
    let x, y;
    if ($f0bf98aa79b5dc9b$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $f0bf98aa79b5dc9b$export$df995fae86a55f06(evt, chart) {
    if ("native" in evt) return evt;
    const { canvas: canvas , currentDevicePixelRatio: currentDevicePixelRatio  } = chart;
    const style = $f0bf98aa79b5dc9b$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $f0bf98aa79b5dc9b$var$getPositionedStyle(style, "padding");
    const borders = $f0bf98aa79b5dc9b$var$getPositionedStyle(style, "border", "width");
    const { x: x , y: y , box: box  } = $f0bf98aa79b5dc9b$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width , height: height  } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $f0bf98aa79b5dc9b$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $f0bf98aa79b5dc9b$export$2329c99376c9d0a4(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $f0bf98aa79b5dc9b$var$getComputedStyle(container);
            const containerBorder = $f0bf98aa79b5dc9b$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $f0bf98aa79b5dc9b$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $f0bf98aa79b5dc9b$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $f0bf98aa79b5dc9b$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $f0bf98aa79b5dc9b$export$527e9aa3390079e9,
        maxHeight: maxHeight || $f0bf98aa79b5dc9b$export$527e9aa3390079e9
    };
}
const $f0bf98aa79b5dc9b$var$round1 = (v)=>Math.round(v * 10) / 10;
function $f0bf98aa79b5dc9b$export$d66501df72047452(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $f0bf98aa79b5dc9b$var$getComputedStyle(canvas);
    const margins = $f0bf98aa79b5dc9b$var$getPositionedStyle(style, "margin");
    const maxWidth = $f0bf98aa79b5dc9b$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $f0bf98aa79b5dc9b$export$527e9aa3390079e9;
    const maxHeight = $f0bf98aa79b5dc9b$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $f0bf98aa79b5dc9b$export$527e9aa3390079e9;
    const containerSize = $f0bf98aa79b5dc9b$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width , height: height  } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $f0bf98aa79b5dc9b$var$getPositionedStyle(style, "border", "width");
        const paddings = $f0bf98aa79b5dc9b$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $f0bf98aa79b5dc9b$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $f0bf98aa79b5dc9b$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $f0bf98aa79b5dc9b$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $f0bf98aa79b5dc9b$export$4c3d22f3d993c33f(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $f0bf98aa79b5dc9b$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $f0bf98aa79b5dc9b$export$9bb611d729802a56(element, property) {
    const value = $f0bf98aa79b5dc9b$export$1ee57be6f6687d2c(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $f0bf98aa79b5dc9b$export$306ddfe3a8403e2(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $f0bf98aa79b5dc9b$export$7a38258bbe170828(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5(p1, cp1, t);
    const b = $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5(cp1, cp2, t);
    const c = $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5(cp2, p2, t);
    const d = $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5(a, b, t);
    const e = $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5(b, c, t);
    return $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5(d, e, t);
}
const $f0bf98aa79b5dc9b$var$intlCache = new Map();
function $f0bf98aa79b5dc9b$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $f0bf98aa79b5dc9b$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $f0bf98aa79b5dc9b$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $f0bf98aa79b5dc9b$export$ae1af26003f05816(num, locale, options) {
    return $f0bf98aa79b5dc9b$var$getNumberFormat(locale, options).format(num);
}
const $f0bf98aa79b5dc9b$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $f0bf98aa79b5dc9b$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $f0bf98aa79b5dc9b$export$28f7fcd39efa255(rtl, rectX, width) {
    return rtl ? $f0bf98aa79b5dc9b$var$getRightToLeftAdapter(rectX, width) : $f0bf98aa79b5dc9b$var$getLeftToRightAdapter();
}
function $f0bf98aa79b5dc9b$export$3d12bd131bb975d1(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction"), 
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $f0bf98aa79b5dc9b$export$9d398bebfec1c039(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $f0bf98aa79b5dc9b$var$propertyFn(property) {
    if (property === "angle") return {
        between: $f0bf98aa79b5dc9b$export$ffb5f4729a158638,
        compare: $f0bf98aa79b5dc9b$export$d29e374196577086,
        normalize: $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce
    };
    return {
        between: $f0bf98aa79b5dc9b$export$f38c853ae54ed474,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $f0bf98aa79b5dc9b$var$normalizeSegment({ start: start , end: end , count: count , loop: loop , style: style  }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $f0bf98aa79b5dc9b$var$getSegment(segment, points, bounds) {
    const { property: property , start: startBound , end: endBound  } = bounds;
    const { between: between , normalize: normalize  } = $f0bf98aa79b5dc9b$var$propertyFn(property);
    const count = points.length;
    let { start: start , end: end , loop: loop  } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $f0bf98aa79b5dc9b$export$92108d983e8ee699(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property , start: startBound , end: endBound  } = bounds;
    const count = points.length;
    const { compare: compare , between: between , normalize: normalize  } = $f0bf98aa79b5dc9b$var$propertyFn(property);
    const { start: start , end: end , loop: loop , style: style  } = $f0bf98aa79b5dc9b$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($f0bf98aa79b5dc9b$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($f0bf98aa79b5dc9b$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $f0bf98aa79b5dc9b$export$1a82df3d29112e01(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $f0bf98aa79b5dc9b$export$92108d983e8ee699(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $f0bf98aa79b5dc9b$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $f0bf98aa79b5dc9b$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $f0bf98aa79b5dc9b$export$ab83b03e4111b1d0(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start , end: end  } = $f0bf98aa79b5dc9b$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $f0bf98aa79b5dc9b$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $f0bf98aa79b5dc9b$var$splitByStyles(line, $f0bf98aa79b5dc9b$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $f0bf98aa79b5dc9b$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $f0bf98aa79b5dc9b$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $f0bf98aa79b5dc9b$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $f0bf98aa79b5dc9b$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex , options: { spanGaps: spanGaps  }  } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $f0bf98aa79b5dc9b$var$readStyle(segmentOptions.setContext($f0bf98aa79b5dc9b$export$dda1d9f60106f0e9(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($f0bf98aa79b5dc9b$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $f0bf98aa79b5dc9b$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $f0bf98aa79b5dc9b$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}



class $a43aa20d3eb44e80$var$Animator {
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $f0bf98aa79b5dc9b$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw1 = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw1 = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw1) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
}
var $a43aa20d3eb44e80$export$a424a0aa8f687495 = new $a43aa20d3eb44e80$var$Animator();
const $a43aa20d3eb44e80$var$transparent = "transparent";
const $a43aa20d3eb44e80$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $f0bf98aa79b5dc9b$export$db3b6bfb95261072)(from || $a43aa20d3eb44e80$var$transparent);
        const c1 = c0.valid && (0, $f0bf98aa79b5dc9b$export$db3b6bfb95261072)(to || $a43aa20d3eb44e80$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $a43aa20d3eb44e80$export$c35d437ae5945fcd {
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $f0bf98aa79b5dc9b$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $f0bf98aa79b5dc9b$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $f0bf98aa79b5dc9b$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $f0bf98aa79b5dc9b$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $a43aa20d3eb44e80$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $f0bf98aa79b5dc9b$export$f1e1789686576879)[cfg.easing] || (0, $f0bf98aa79b5dc9b$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
}
const $a43aa20d3eb44e80$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $a43aa20d3eb44e80$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).set("animation", {
    delay: undefined,
    duration: 1000,
    easing: "easeOutQuart",
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $a43aa20d3eb44e80$var$animationOptions = Object.keys((0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).animation);
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).set("animations", {
    colors: {
        type: "color",
        properties: $a43aa20d3eb44e80$var$colors
    },
    numbers: {
        type: "number",
        properties: $a43aa20d3eb44e80$var$numbers
    }
});
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).describe("animations", {
    _fallback: "animation"
});
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $a43aa20d3eb44e80$export$8ab227dac26677d {
    configure(config) {
        if (!(0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of $a43aa20d3eb44e80$var$animationOptions)resolved[option] = cfg[option];
            ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $a43aa20d3eb44e80$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $a43aa20d3eb44e80$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $a43aa20d3eb44e80$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $a43aa20d3eb44e80$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
}
function $a43aa20d3eb44e80$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $a43aa20d3eb44e80$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $a43aa20d3eb44e80$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $a43aa20d3eb44e80$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $a43aa20d3eb44e80$var$scaleClip(xScale, allowedOverflow);
    const y = $a43aa20d3eb44e80$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $a43aa20d3eb44e80$var$toClip(value) {
    let t, r, b, l;
    if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $a43aa20d3eb44e80$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $a43aa20d3eb44e80$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(value) === (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $a43aa20d3eb44e80$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $a43aa20d3eb44e80$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $a43aa20d3eb44e80$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $a43aa20d3eb44e80$var$getUserBounds(scale) {
    const { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $a43aa20d3eb44e80$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $a43aa20d3eb44e80$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $a43aa20d3eb44e80$var$updateStacks(controller, parsed) {
    const { chart: chart , _cachedMeta: meta  } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale , vScale: vScale , index: datasetIndex  } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $a43aa20d3eb44e80$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index1 , [vAxis]: value  } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $a43aa20d3eb44e80$var$getOrCreateStack(stacks, key, index1);
        stack[datasetIndex] = value;
        stack._top = $a43aa20d3eb44e80$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $a43aa20d3eb44e80$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $a43aa20d3eb44e80$var$getFirstScaleId(chart, axis) {
    const scales1 = chart.scales;
    return Object.keys(scales1).filter((key)=>scales1[key].axis === axis).shift();
}
function $a43aa20d3eb44e80$var$createDatasetContext(parent, index2) {
    return (0, $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index2,
        index: index2,
        mode: "default",
        type: "dataset"
    });
}
function $a43aa20d3eb44e80$var$createDataContext(parent, index3, element) {
    return (0, $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataIndex: index3,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index3,
        mode: "default",
        type: "data"
    });
}
function $a43aa20d3eb44e80$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
    }
}
const $a43aa20d3eb44e80$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $a43aa20d3eb44e80$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $a43aa20d3eb44e80$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $a43aa20d3eb44e80$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $a43aa20d3eb44e80$export$75572ec5c55b4048 {
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $a43aa20d3eb44e80$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $a43aa20d3eb44e80$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(dataset.xAxisID, $a43aa20d3eb44e80$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(dataset.yAxisID, $a43aa20d3eb44e80$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(dataset.rAxisID, $a43aa20d3eb44e80$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $f0bf98aa79b5dc9b$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $a43aa20d3eb44e80$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(data)) this._data = $a43aa20d3eb44e80$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $f0bf98aa79b5dc9b$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $a43aa20d3eb44e80$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $f0bf98aa79b5dc9b$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $a43aa20d3eb44e80$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $a43aa20d3eb44e80$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $a43aa20d3eb44e80$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta , _data: data  } = this;
        const { iScale: iScale , _stacked: _stacked  } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $a43aa20d3eb44e80$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale , vScale: vScale  } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index4;
        for(i = 0, ilen = count; i < ilen; ++i){
            index4 = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index4], index4),
                [vAxis]: vScale.parse(data[index4], index4)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale , yScale: yScale  } = meta;
        const parsed = new Array(count);
        let i, ilen, index5, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index5 = i + start;
            item = data[index5];
            parsed[i] = {
                x: xScale.parse(item[0], index5),
                y: yScale.parse(item[1], index5)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale , yScale: yScale  } = meta;
        const { xAxisKey: xAxisKey = "x" , yAxisKey: yAxisKey = "y"  } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index6, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index6 = i + start;
            item = data[index6];
            parsed[i] = {
                x: xScale.parse((0, $f0bf98aa79b5dc9b$export$2d1720544b23b823)(item, xAxisKey), index6),
                y: yScale.parse((0, $f0bf98aa79b5dc9b$export$2d1720544b23b823)(item, yAxisKey), index6)
            };
        }
        return parsed;
    }
    getParsed(index7) {
        return this._cachedMeta._parsed[index7];
    }
    getDataElement(index8) {
        return this._cachedMeta.data[index8];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $a43aa20d3eb44e80$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $a43aa20d3eb44e80$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $a43aa20d3eb44e80$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $a43aa20d3eb44e80$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin , max: otherMax  } = $a43aa20d3eb44e80$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index9) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index9);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $a43aa20d3eb44e80$var$toClip((0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(this.options.clip, $a43aa20d3eb44e80$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements1 = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements1.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements1[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index10, active) {
        const mode = active ? "active" : "default";
        return index10 === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index10 || 0, mode);
    }
    getContext(index11, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index11 >= 0 && index11 < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index11];
            context = element.$context || (element.$context = $a43aa20d3eb44e80$var$createDataContext(this.getContext(), index11, element));
            context.parsed = this.getParsed(index11);
            context.raw = dataset.data[index11];
            context.index = context.dataIndex = index11;
        } else {
            context = this.$context || (this.$context = $a43aa20d3eb44e80$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index12, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index12);
    }
    _resolveElementOptions(elementType, mode = "default", index13) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $f0bf98aa79b5dc9b$export$35e795649ee09318)(index13);
        if (cached) return $a43aa20d3eb44e80$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index13, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($a43aa20d3eb44e80$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index14, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index14, active, transition));
        }
        const animations = new $a43aa20d3eb44e80$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $a43aa20d3eb44e80$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    updateElement(element, index15, properties, mode) {
        if ($a43aa20d3eb44e80$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index15, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$a43aa20d3eb44e80$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index16, mode, active) {
        element.active = active;
        const options = this.getStyle(index16, active);
        this._resolveAnimations(index16, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index17) {
        this._setStyle(element, index17, "active", false);
    }
    setHoverStyle(element, datasetIndex, index18) {
        this._setStyle(element, index18, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements2 = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements2.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $a43aa20d3eb44e80$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
}
$a43aa20d3eb44e80$export$75572ec5c55b4048.defaults = {};
$a43aa20d3eb44e80$export$75572ec5c55b4048.prototype.datasetElementType = null;
$a43aa20d3eb44e80$export$75572ec5c55b4048.prototype.dataElementType = null;
function $a43aa20d3eb44e80$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $f0bf98aa79b5dc9b$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $a43aa20d3eb44e80$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $a43aa20d3eb44e80$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $f0bf98aa79b5dc9b$export$35e795649ee09318)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $a43aa20d3eb44e80$var$computeFitCategoryTraits(index19, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index19] - size / 2
    };
}
function $a43aa20d3eb44e80$var$computeFlexCategoryTraits(index20, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index20];
    let prev = index20 > 0 ? pixels[index20 - 1] : null;
    let next = index20 < pixels.length - 1 ? pixels[index20 + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $a43aa20d3eb44e80$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $a43aa20d3eb44e80$var$parseValue(entry, item, vScale, i) {
    if ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(entry)) $a43aa20d3eb44e80$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $a43aa20d3eb44e80$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($a43aa20d3eb44e80$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $a43aa20d3eb44e80$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $a43aa20d3eb44e80$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $a43aa20d3eb44e80$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $a43aa20d3eb44e80$var$setBorderSkipped(properties, options, stack, index21) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    const { start: start , end: end , reverse: reverse , top: top , bottom: bottom  } = $a43aa20d3eb44e80$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index21) edge = top;
        else if ((stack._bottom || 0) === index21) edge = bottom;
        else {
            res[$a43aa20d3eb44e80$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$a43aa20d3eb44e80$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $a43aa20d3eb44e80$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $a43aa20d3eb44e80$var$swap(edge, a, b);
        edge = $a43aa20d3eb44e80$var$startEnd(edge, b, a);
    } else edge = $a43aa20d3eb44e80$var$startEnd(edge, a, b);
    return edge;
}
function $a43aa20d3eb44e80$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $a43aa20d3eb44e80$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $a43aa20d3eb44e80$var$setInflateAmount(properties, { inflateAmount: inflateAmount  }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $a43aa20d3eb44e80$export$e97d5dc64e999004 extends $a43aa20d3eb44e80$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $a43aa20d3eb44e80$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $a43aa20d3eb44e80$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale , vScale: vScale  } = meta;
        const { xAxisKey: xAxisKey = "x" , yAxisKey: yAxisKey = "y"  } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $f0bf98aa79b5dc9b$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($a43aa20d3eb44e80$var$parseValue((0, $f0bf98aa79b5dc9b$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index22) {
        const meta = this._cachedMeta;
        const { iScale: iScale , vScale: vScale  } = meta;
        const parsed = this.getParsed(index22);
        const custom = parsed._custom;
        const value = $a43aa20d3eb44e80$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index23 , _cachedMeta: { vScale: vScale  }  } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $a43aa20d3eb44e80$var$isFloatBar(parsed._custom) || index23 === stack._top || index23 === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $a43aa20d3eb44e80$var$setBorderSkipped(properties, options, stack, index23);
            $a43aa20d3eb44e80$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const metasets = iScale.getMatchingVisibleMetas(this._type);
        const stacked = iScale.options.stacked;
        const ilen = metasets.length;
        const stacks = [];
        let i, item;
        for(i = 0; i < ilen; ++i){
            item = metasets[i];
            if (!item.controller.options.grouped) continue;
            if (typeof dataIndex !== "undefined") {
                const val = item.controller.getParsed(dataIndex)[item.controller._cachedMeta.vScale.axis];
                if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(val) || isNaN(val)) continue;
            }
            if (stacked === false || stacks.indexOf(item.stack) === -1 || stacked === undefined && item.stack === undefined) stacks.push(item.stack);
            if (item.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index24) {
        return this._getStacks(undefined, index24).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index25 = name !== undefined ? stacks.indexOf(name) : -1;
        return index25 === -1 ? stacks.length - 1 : index25;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $a43aa20d3eb44e80$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index26) {
        const { _cachedMeta: { vScale: vScale , _stacked: _stacked  } , options: { base: baseValue , minBarLength: minBarLength  }  } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index26);
        const custom = parsed._custom;
        const floating = $a43aa20d3eb44e80$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(value) !== (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index26)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $a43aa20d3eb44e80$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index27, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index27) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $a43aa20d3eb44e80$var$computeFlexCategoryTraits(index27, ruler, options, stackCount) : $a43aa20d3eb44e80$var$computeFitCategoryTraits(index27, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index27 : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index27)[scale.axis], index27);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$a43aa20d3eb44e80$export$e97d5dc64e999004.id = "bar";
$a43aa20d3eb44e80$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$a43aa20d3eb44e80$export$e97d5dc64e999004.overrides = {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $a43aa20d3eb44e80$export$19b5c4773f17abe extends $a43aa20d3eb44e80$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index28) {
        const meta = this._cachedMeta;
        const { xScale: xScale , yScale: yScale  } = meta;
        const parsed = this.getParsed(index28);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale , vScale: vScale  } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    resolveDataElementOptions(index29, mode) {
        const parsed = this.getParsed(index29);
        let values = super.resolveDataElementOptions(index29, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
$a43aa20d3eb44e80$export$19b5c4773f17abe.id = "bubble";
$a43aa20d3eb44e80$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$a43aa20d3eb44e80$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $a43aa20d3eb44e80$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $f0bf98aa79b5dc9b$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $f0bf98aa79b5dc9b$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d) + (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $a43aa20d3eb44e80$export$e04603e7d8b77172 extends $a43aa20d3eb44e80$export$75572ec5c55b4048 {
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value"  } = this._parsing;
                getter = (i)=>+(0, $f0bf98aa79b5dc9b$export$2d1720544b23b823)(data[i], key);
            }
            let i1, ilen;
            for(i1 = start, ilen = start + count; i1 < ilen; ++i1)meta._parsed[i1] = getter(i1);
        }
    }
    _getRotation() {
        return (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7);
        let max = -(0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea  } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $f0bf98aa79b5dc9b$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference , rotation: rotation  } = this._getRotationExtents();
        const { ratioX: ratioX , ratioY: ratioY , offsetX: offsetX , offsetY: offsetY  } = $a43aa20d3eb44e80$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $f0bf98aa79b5dc9b$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index30) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $f0bf98aa79b5dc9b$export$ae1af26003f05816)(meta._parsed[index30], chart.options.locale);
        return {
            label: labels[index30] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
}
$a43aa20d3eb44e80$export$e04603e7d8b77172.id = "doughnut";
$a43aa20d3eb44e80$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$a43aa20d3eb44e80$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$a43aa20d3eb44e80$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle  }  } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $a43aa20d3eb44e80$export$3c9b5d28c11cbfd0 extends $a43aa20d3eb44e80$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line , data: points = [] , _dataset: _dataset  } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start , count: count  } = $a43aa20d3eb44e80$var$getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ($a43aa20d3eb44e80$var$scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale , vScale: vScale , _stacked: _stacked , _dataset: _dataset  } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps , segment: segment  } = this.options;
        const maxGapLength = (0, $f0bf98aa79b5dc9b$export$9e5f44173e64f162)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$a43aa20d3eb44e80$export$3c9b5d28c11cbfd0.id = "line";
$a43aa20d3eb44e80$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$a43aa20d3eb44e80$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
function $a43aa20d3eb44e80$var$getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale , _parsed: _parsed  } = meta;
        const axis = iScale.axis;
        const { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = iScale.getUserBounds();
        if (minDefined) start = (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(Math.min((0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : (0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(Math.max((0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(_parsed, iScale.axis, max).hi + 1, animationsDisabled ? 0 : (0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(points, axis, iScale.getPixelForValue(max)).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $a43aa20d3eb44e80$var$scaleRangesChanged(meta) {
    const { xScale: xScale , yScale: yScale , _scaleRanges: _scaleRanges  } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
class $a43aa20d3eb44e80$export$2a270b3a0d973c85 extends $a43aa20d3eb44e80$export$75572ec5c55b4048 {
    getLabelAndValue(index31) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $f0bf98aa79b5dc9b$export$ae1af26003f05816)(meta._parsed[index31].r, chart.options.locale);
        return {
            label: labels[index31] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $f0bf98aa79b5dc9b$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index32)=>{
            const parsed = this.getParsed(index32).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index32)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index33)=>{
            if (!isNaN(this.getParsed(index33).r) && this.chart.getDataVisibility(index33)) count++;
        });
        return count;
    }
    _computeAngle(index34, mode, defaultAngle) {
        return this.chart.getDataVisibility(index34) ? (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.resolveDataElementOptions(index34, mode).angle || defaultAngle) : 0;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
}
$a43aa20d3eb44e80$export$2a270b3a0d973c85.id = "polarArea";
$a43aa20d3eb44e80$export$2a270b3a0d973c85.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$a43aa20d3eb44e80$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle  }  } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $a43aa20d3eb44e80$export$b21a3f1286706191 extends $a43aa20d3eb44e80$export$e04603e7d8b77172 {
}
$a43aa20d3eb44e80$export$b21a3f1286706191.id = "pie";
$a43aa20d3eb44e80$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $a43aa20d3eb44e80$export$48dbc6ac651bf8be extends $a43aa20d3eb44e80$export$75572ec5c55b4048 {
    getLabelAndValue(index35) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index35);
        return {
            label: vScale.getLabels()[index35],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $f0bf98aa79b5dc9b$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$a43aa20d3eb44e80$export$48dbc6ac651bf8be.id = "radar";
$a43aa20d3eb44e80$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$a43aa20d3eb44e80$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
class $a43aa20d3eb44e80$export$b2f2bae6713db87 extends $a43aa20d3eb44e80$export$3c9b5d28c11cbfd0 {
}
$a43aa20d3eb44e80$export$b2f2bae6713db87.id = "scatter";
$a43aa20d3eb44e80$export$b2f2bae6713db87.defaults = {
    showLine: false,
    fill: false
};
$a43aa20d3eb44e80$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
var $a43aa20d3eb44e80$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $a43aa20d3eb44e80$export$e97d5dc64e999004,
    BubbleController: $a43aa20d3eb44e80$export$19b5c4773f17abe,
    DoughnutController: $a43aa20d3eb44e80$export$e04603e7d8b77172,
    LineController: $a43aa20d3eb44e80$export$3c9b5d28c11cbfd0,
    PolarAreaController: $a43aa20d3eb44e80$export$2a270b3a0d973c85,
    PieController: $a43aa20d3eb44e80$export$b21a3f1286706191,
    RadarController: $a43aa20d3eb44e80$export$48dbc6ac651bf8be,
    ScatterController: $a43aa20d3eb44e80$export$b2f2bae6713db87
});
function $a43aa20d3eb44e80$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $a43aa20d3eb44e80$var$DateAdapter {
    formats() {
        return $a43aa20d3eb44e80$var$abstract();
    }
    parse(value, format) {
        return $a43aa20d3eb44e80$var$abstract();
    }
    format(timestamp, format) {
        return $a43aa20d3eb44e80$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $a43aa20d3eb44e80$var$abstract();
    }
    diff(a, b, unit) {
        return $a43aa20d3eb44e80$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $a43aa20d3eb44e80$var$abstract();
    }
    endOf(timestamp, unit) {
        return $a43aa20d3eb44e80$var$abstract();
    }
    constructor(options){
        this.options = options || {};
    }
}
$a43aa20d3eb44e80$var$DateAdapter.override = function(members) {
    Object.assign($a43aa20d3eb44e80$var$DateAdapter.prototype, members);
};
var $a43aa20d3eb44e80$export$f32766ea09ec8bc4 = {
    _date: $a43aa20d3eb44e80$var$DateAdapter
};
function $a43aa20d3eb44e80$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller , data: data , _sorted: _sorted  } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $f0bf98aa79b5dc9b$export$ebd11618f299a286) : (0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $a43aa20d3eb44e80$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index36 , data: data  } = metasets[i];
        const { lo: lo , hi: hi  } = $a43aa20d3eb44e80$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index36, j);
        }
    }
}
function $a43aa20d3eb44e80$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $a43aa20d3eb44e80$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index37) {
        if (!includeInvisible && !(0, $f0bf98aa79b5dc9b$export$ef35774e6d314e91)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index37
        });
    };
    $a43aa20d3eb44e80$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $a43aa20d3eb44e80$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index38) {
        const { startAngle: startAngle , endAngle: endAngle  } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle  } = (0, $f0bf98aa79b5dc9b$export$e7094788287c5e9b)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $f0bf98aa79b5dc9b$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index38
        });
    }
    $a43aa20d3eb44e80$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $a43aa20d3eb44e80$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $a43aa20d3eb44e80$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index39) {
        const inRange1 = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange1) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange1) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index39
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index39
        });
    }
    $a43aa20d3eb44e80$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $a43aa20d3eb44e80$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $a43aa20d3eb44e80$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $a43aa20d3eb44e80$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $a43aa20d3eb44e80$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $a43aa20d3eb44e80$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index40)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index40
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $a43aa20d3eb44e80$export$a13296960cae0384 = {
    evaluateInteractionItems: $a43aa20d3eb44e80$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $f0bf98aa79b5dc9b$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $a43aa20d3eb44e80$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $a43aa20d3eb44e80$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements3 = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index41 = items[0].index;
                const element = meta.data[index41];
                if (element && !element.skip) elements3.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index41
                });
            });
            return elements3;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $f0bf98aa79b5dc9b$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $a43aa20d3eb44e80$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $a43aa20d3eb44e80$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $f0bf98aa79b5dc9b$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $a43aa20d3eb44e80$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $f0bf98aa79b5dc9b$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $a43aa20d3eb44e80$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $f0bf98aa79b5dc9b$export$df995fae86a55f06)(e, chart);
            return $a43aa20d3eb44e80$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $f0bf98aa79b5dc9b$export$df995fae86a55f06)(e, chart);
            return $a43aa20d3eb44e80$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $a43aa20d3eb44e80$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $a43aa20d3eb44e80$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $a43aa20d3eb44e80$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$a43aa20d3eb44e80$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $a43aa20d3eb44e80$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $a43aa20d3eb44e80$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos , options: { stack: stack , stackWeight: stackWeight = 1  }  } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $a43aa20d3eb44e80$var$buildStacks(layouts1) {
    const stacks = {};
    for (const wrap of layouts1){
        const { stack: stack , pos: pos , stackWeight: stackWeight  } = wrap;
        if (!stack || !$a43aa20d3eb44e80$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $a43aa20d3eb44e80$var$setLayoutDims(layouts2, params) {
    const stacks = $a43aa20d3eb44e80$var$buildStacks(layouts2);
    const { vBoxMaxWidth: vBoxMaxWidth , hBoxMaxHeight: hBoxMaxHeight  } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts2.length; i < ilen; ++i){
        layout = layouts2[i];
        const { fullSize: fullSize  } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $a43aa20d3eb44e80$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $a43aa20d3eb44e80$var$wrapBoxes(boxes);
    const fullSize = $a43aa20d3eb44e80$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $a43aa20d3eb44e80$var$sortByWeight($a43aa20d3eb44e80$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $a43aa20d3eb44e80$var$sortByWeight($a43aa20d3eb44e80$var$filterByPosition(layoutBoxes, "right"));
    const top = $a43aa20d3eb44e80$var$sortByWeight($a43aa20d3eb44e80$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $a43aa20d3eb44e80$var$sortByWeight($a43aa20d3eb44e80$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $a43aa20d3eb44e80$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $a43aa20d3eb44e80$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $a43aa20d3eb44e80$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $a43aa20d3eb44e80$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $a43aa20d3eb44e80$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $a43aa20d3eb44e80$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos , box: box  } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $a43aa20d3eb44e80$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $a43aa20d3eb44e80$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $a43aa20d3eb44e80$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $a43aa20d3eb44e80$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $a43aa20d3eb44e80$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $a43aa20d3eb44e80$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $a43aa20d3eb44e80$var$getMargins(layout.horizontal, chartArea));
        const { same: same , other: other  } = $a43aa20d3eb44e80$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $a43aa20d3eb44e80$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $a43aa20d3eb44e80$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $a43aa20d3eb44e80$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x , y: y  } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $f0bf98aa79b5dc9b$export$35e795649ee09318)(stack.start)) y = stack.start;
            if (box.fullSize) $a43aa20d3eb44e80$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $a43aa20d3eb44e80$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $f0bf98aa79b5dc9b$export$35e795649ee09318)(stack.start)) x = stack.start;
            if (box.fullSize) $a43aa20d3eb44e80$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $a43aa20d3eb44e80$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).set("layout", {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $a43aa20d3eb44e80$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index42 = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index42 !== -1) chart.boxes.splice(index42, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $a43aa20d3eb44e80$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $a43aa20d3eb44e80$var$updateMaxPadding(maxPadding, (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $a43aa20d3eb44e80$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $a43aa20d3eb44e80$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $a43aa20d3eb44e80$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($a43aa20d3eb44e80$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $a43aa20d3eb44e80$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $a43aa20d3eb44e80$var$handleMaxPadding(chartArea);
        $a43aa20d3eb44e80$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $a43aa20d3eb44e80$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $a43aa20d3eb44e80$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $a43aa20d3eb44e80$export$a40a96b24b46cf35 extends $a43aa20d3eb44e80$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $a43aa20d3eb44e80$var$EXPANDO_KEY = "$chartjs";
const $a43aa20d3eb44e80$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $a43aa20d3eb44e80$var$isNullOrEmpty = (value)=>value === null || value === "";
function $a43aa20d3eb44e80$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$a43aa20d3eb44e80$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($a43aa20d3eb44e80$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $f0bf98aa79b5dc9b$export$9bb611d729802a56)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($a43aa20d3eb44e80$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $f0bf98aa79b5dc9b$export$9bb611d729802a56)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $a43aa20d3eb44e80$var$eventListenerOptions = (0, $f0bf98aa79b5dc9b$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $a43aa20d3eb44e80$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $a43aa20d3eb44e80$var$eventListenerOptions);
}
function $a43aa20d3eb44e80$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $a43aa20d3eb44e80$var$eventListenerOptions);
}
function $a43aa20d3eb44e80$var$fromNativeEvent(event, chart) {
    const type = $a43aa20d3eb44e80$var$EVENT_TYPES[event.type] || event.type;
    const { x: x , y: y  } = (0, $f0bf98aa79b5dc9b$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $a43aa20d3eb44e80$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $a43aa20d3eb44e80$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $a43aa20d3eb44e80$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$a43aa20d3eb44e80$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $a43aa20d3eb44e80$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $a43aa20d3eb44e80$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$a43aa20d3eb44e80$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $a43aa20d3eb44e80$var$drpListeningCharts = new Map();
let $a43aa20d3eb44e80$var$oldDevicePixelRatio = 0;
function $a43aa20d3eb44e80$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $a43aa20d3eb44e80$var$oldDevicePixelRatio) return;
    $a43aa20d3eb44e80$var$oldDevicePixelRatio = dpr;
    $a43aa20d3eb44e80$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $a43aa20d3eb44e80$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$a43aa20d3eb44e80$var$drpListeningCharts.size) window.addEventListener("resize", $a43aa20d3eb44e80$var$onWindowResize);
    $a43aa20d3eb44e80$var$drpListeningCharts.set(chart, resize);
}
function $a43aa20d3eb44e80$var$unlistenDevicePixelRatioChanges(chart) {
    $a43aa20d3eb44e80$var$drpListeningCharts.delete(chart);
    if (!$a43aa20d3eb44e80$var$drpListeningCharts.size) window.removeEventListener("resize", $a43aa20d3eb44e80$var$onWindowResize);
}
function $a43aa20d3eb44e80$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $f0bf98aa79b5dc9b$export$2329c99376c9d0a4)(canvas);
    if (!container) return;
    const resize = (0, $f0bf98aa79b5dc9b$export$b4171a6734a65d42)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $a43aa20d3eb44e80$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $a43aa20d3eb44e80$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $a43aa20d3eb44e80$var$unlistenDevicePixelRatioChanges(chart);
}
function $a43aa20d3eb44e80$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $f0bf98aa79b5dc9b$export$b4171a6734a65d42)((event)=>{
        if (chart.ctx !== null) listener($a43aa20d3eb44e80$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $a43aa20d3eb44e80$var$addListener(canvas, type, proxy);
    return proxy;
}
class $a43aa20d3eb44e80$export$f02da7f882cf6b2e extends $a43aa20d3eb44e80$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $a43aa20d3eb44e80$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$a43aa20d3eb44e80$var$EXPANDO_KEY]) return false;
        const initial = canvas[$a43aa20d3eb44e80$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$a43aa20d3eb44e80$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $a43aa20d3eb44e80$var$createAttachObserver,
            detach: $a43aa20d3eb44e80$var$createDetachObserver,
            resize: $a43aa20d3eb44e80$var$createResizeObserver
        };
        const handler = handlers[type] || $a43aa20d3eb44e80$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $a43aa20d3eb44e80$var$releaseObserver,
            detach: $a43aa20d3eb44e80$var$releaseObserver,
            resize: $a43aa20d3eb44e80$var$releaseObserver
        };
        const handler = handlers[type] || $a43aa20d3eb44e80$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $f0bf98aa79b5dc9b$export$d66501df72047452)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $f0bf98aa79b5dc9b$export$2329c99376c9d0a4)(canvas);
        return !!(container && container.isConnected);
    }
}
function $a43aa20d3eb44e80$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $f0bf98aa79b5dc9b$export$61196ced6d74a310)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $a43aa20d3eb44e80$export$a40a96b24b46cf35;
    return $a43aa20d3eb44e80$export$f02da7f882cf6b2e;
}
class $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    tooltipPosition(useFinalPosition) {
        const { x: x , y: y  } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $f0bf98aa79b5dc9b$export$9e5f44173e64f162)(this.x) && (0, $f0bf98aa79b5dc9b$export$9e5f44173e64f162)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
}
$a43aa20d3eb44e80$export$db77ccec0bb4ccac.defaults = {};
$a43aa20d3eb44e80$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $a43aa20d3eb44e80$var$formatters = {
    values (value) {
        return (0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $a43aa20d3eb44e80$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $f0bf98aa79b5dc9b$export$ae1af26003f05816)(tickValue, locale, options);
    },
    logarithmic (tickValue, index43, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor((0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $a43aa20d3eb44e80$var$formatters.numeric.call(this, tickValue, index43, ticks);
        return "";
    }
};
function $a43aa20d3eb44e80$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $a43aa20d3eb44e80$export$27c7467594ef87bd = {
    formatters: $a43aa20d3eb44e80$var$formatters
};
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $a43aa20d3eb44e80$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).route("scale.ticks", "color", "", "color");
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).route("scale.grid", "color", "", "borderColor");
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).route("scale.grid", "borderColor", "", "borderColor");
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).route("scale.title", "color", "", "color");
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).describe("scales", {
    _fallback: "scale"
});
(0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $a43aa20d3eb44e80$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $a43aa20d3eb44e80$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $a43aa20d3eb44e80$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $a43aa20d3eb44e80$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $a43aa20d3eb44e80$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $a43aa20d3eb44e80$var$skip(ticks, newTicks, spacing, (0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$a43aa20d3eb44e80$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $a43aa20d3eb44e80$var$skip(ticks, newTicks, spacing, last, (0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $a43aa20d3eb44e80$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $a43aa20d3eb44e80$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $a43aa20d3eb44e80$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $a43aa20d3eb44e80$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $f0bf98aa79b5dc9b$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $a43aa20d3eb44e80$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $a43aa20d3eb44e80$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $a43aa20d3eb44e80$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $a43aa20d3eb44e80$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $a43aa20d3eb44e80$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $a43aa20d3eb44e80$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $a43aa20d3eb44e80$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $a43aa20d3eb44e80$var$getPixelForGridLine(scale, index44, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex1 = Math.min(index44, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex1);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index44 === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex1 - 1)) / 2;
        lineValue += validIndex1 < index44 ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $a43aa20d3eb44e80$var$garbageCollect(caches, length) {
    (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $a43aa20d3eb44e80$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $a43aa20d3eb44e80$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.font, fallback);
    const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(options.padding);
    const lines = (0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $a43aa20d3eb44e80$var$createScaleContext(parent, scale) {
    return (0, $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $a43aa20d3eb44e80$var$createTickContext(parent, index45, tick) {
    return (0, $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9)(parent, {
        tick: tick,
        index: index45,
        type: "tick"
    });
}
function $a43aa20d3eb44e80$var$titleAlign(align, position, reverse) {
    let ret = (0, $f0bf98aa79b5dc9b$export$34aec0b863436764)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $a43aa20d3eb44e80$var$reverseAlign(ret);
    return ret;
}
function $a43aa20d3eb44e80$var$titleArgs(scale, offset, position, align) {
    const { top: top , left: left , bottom: bottom , right: right , chart: chart  } = scale;
    const { chartArea: chartArea , scales: scales2  } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, left, right);
        if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales2[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $a43aa20d3eb44e80$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales2[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $a43aa20d3eb44e80$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, bottom, top);
        rotation = position === "left" ? -(0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd) : (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $a43aa20d3eb44e80$export$d60cfc58d3c358b6 extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin , _userMax: _userMax , _suggestedMin: _suggestedMin , _suggestedMax: _suggestedMax  } = this;
        _userMin = (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(min, (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(max, min)),
            max: (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(max, (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero , grace: grace , ticks: tickOpts  } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $f0bf98aa79b5dc9b$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $a43aa20d3eb44e80$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $a43aa20d3eb44e80$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $a43aa20d3eb44e80$var$getTickMarkLength(options.grid) - tickOpts.padding - $a43aa20d3eb44e80$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $f0bf98aa79b5dc9b$export$25ce5a424b770e84)(Math.min(Math.asin((0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart , options: { ticks: tickOpts , title: titleOpts , grid: gridOpts  }  } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $a43aa20d3eb44e80$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $a43aa20d3eb44e80$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $a43aa20d3eb44e80$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first , last: last , widest: widest , highest: highest  } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align , padding: padding  } , position: position  } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis , position: position  } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $a43aa20d3eb44e80$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx , _longestTextCache: caches  } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(label) && !(0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(label)) {
                width = (0, $f0bf98aa79b5dc9b$export$3a6d5c9ae78a2c08)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(nestedLabel) && !(0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $f0bf98aa79b5dc9b$export$3a6d5c9ae78a2c08)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $a43aa20d3eb44e80$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index46) {
        const ticks = this.ticks;
        if (index46 < 0 || index46 > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index46].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $f0bf98aa79b5dc9b$export$e7c866399fa523f5)(this._alignToPixels ? (0, $f0bf98aa79b5dc9b$export$71cec2538cb2c617)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min , max: max  } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index47) {
        const ticks = this.ticks || [];
        if (index47 >= 0 && index47 < ticks.length) {
            const tick = ticks[index47];
            return tick.$context || (tick.$context = $a43aa20d3eb44e80$var$createTickContext(this.getContext(), index47, tick));
        }
        return this.$context || (this.$context = $a43aa20d3eb44e80$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid , position: position  } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $a43aa20d3eb44e80$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $f0bf98aa79b5dc9b$export$71cec2538cb2c617)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = grid.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $a43aa20d3eb44e80$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $f0bf98aa79b5dc9b$export$71cec2538cb2c617)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position , ticks: optionTicks  } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align , crossAlign: crossAlign , padding: padding , mirror: mirror  } = optionTicks;
        const tl = $a43aa20d3eb44e80$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color1 = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color1,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position , ticks: ticks  } = this.options;
        const rotation = -(0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position , ticks: { crossAlign: crossAlign , mirror: mirror , padding: padding  }  } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx , options: { backgroundColor: backgroundColor  } , left: left , top: top , width: width , height: height  } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index48 = ticks.findIndex((t)=>t.value === value);
        if (index48 >= 0) {
            const opts = grid.setContext(this.getContext(index48));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart , ctx: ctx , options: { grid: grid  }  } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $f0bf98aa79b5dc9b$export$71cec2538cb2c617)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $f0bf98aa79b5dc9b$export$71cec2538cb2c617)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $f0bf98aa79b5dc9b$export$71cec2538cb2c617)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $f0bf98aa79b5dc9b$export$71cec2538cb2c617)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $f0bf98aa79b5dc9b$export$78acf4525d8a74c4)(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $f0bf98aa79b5dc9b$export$8743009a87fcb00f)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $f0bf98aa79b5dc9b$export$dc98b0b04f4c7758)(ctx);
    }
    drawTitle() {
        const { ctx: ctx , options: { position: position , title: title , reverse: reverse  }  } = this;
        if (!title.display) return;
        const font = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(title.font);
        const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX , titleY: titleY , maxWidth: maxWidth , rotation: rotation  } = $a43aa20d3eb44e80$var$titleArgs(this, offset, position, align);
        (0, $f0bf98aa79b5dc9b$export$8743009a87fcb00f)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $a43aa20d3eb44e80$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $a43aa20d3eb44e80$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index49) {
        const opts = this.options.ticks.setContext(this.getContext(index49));
        return (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
}
class $a43aa20d3eb44e80$var$TypedRegistry {
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($a43aa20d3eb44e80$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $a43aa20d3eb44e80$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0)[scope]) {
            delete (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $f0bf98aa79b5dc9b$export$ce26c07117d59d6a)[id];
        }
    }
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
}
function $a43aa20d3eb44e80$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $f0bf98aa79b5dc9b$export$6559d589eb85fbb6)(Object.create(null), [
        parentScope ? (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $a43aa20d3eb44e80$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $a43aa20d3eb44e80$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $a43aa20d3eb44e80$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $a43aa20d3eb44e80$var$Registry {
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry1, component) {
        const camelMethod = (0, $f0bf98aa79b5dc9b$export$efca4cbe5dd06740)(method);
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(component["before" + camelMethod], [], component);
        registry1[method](component);
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
    constructor(){
        this.controllers = new $a43aa20d3eb44e80$var$TypedRegistry($a43aa20d3eb44e80$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $a43aa20d3eb44e80$var$TypedRegistry($a43aa20d3eb44e80$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $a43aa20d3eb44e80$var$TypedRegistry(Object, "plugins");
        this.scales = new $a43aa20d3eb44e80$var$TypedRegistry($a43aa20d3eb44e80$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
}
var $a43aa20d3eb44e80$export$4bb7493d241fd8a5 = new $a43aa20d3eb44e80$var$Registry();
class $a43aa20d3eb44e80$var$PluginService {
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors1 = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors1, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors1, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors2, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors2){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors3 = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors3;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins1 = $a43aa20d3eb44e80$var$allPlugins(config);
        return options === false && !all ? [] : $a43aa20d3eb44e80$var$createDescriptors(chart, plugins1, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors4 = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors4), chart, "stop");
        this._notify(diff(descriptors4, previousDescriptors), chart, "start");
    }
    constructor(){
        this._init = [];
    }
}
function $a43aa20d3eb44e80$var$allPlugins(config) {
    const plugins2 = [];
    const keys = Object.keys($a43aa20d3eb44e80$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins2.push($a43aa20d3eb44e80$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i3 = 0; i3 < local.length; i3++){
        const plugin = local[i3];
        if (plugins2.indexOf(plugin) === -1) plugins2.push(plugin);
    }
    return plugins2;
}
function $a43aa20d3eb44e80$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $a43aa20d3eb44e80$var$createDescriptors(chart, plugins3, options, all) {
    const result = [];
    const context = chart.getContext();
    for(let i = 0; i < plugins3.length; i++){
        const plugin = plugins3[i];
        const id = plugin.id;
        const opts = $a43aa20d3eb44e80$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $a43aa20d3eb44e80$var$pluginOpts(chart.config, plugin, opts, context)
        });
    }
    return result;
}
function $a43aa20d3eb44e80$var$pluginOpts(config, plugin, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $a43aa20d3eb44e80$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $a43aa20d3eb44e80$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $a43aa20d3eb44e80$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $a43aa20d3eb44e80$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $a43aa20d3eb44e80$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $a43aa20d3eb44e80$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $a43aa20d3eb44e80$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $f0bf98aa79b5dc9b$export$ce26c07117d59d6a)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $a43aa20d3eb44e80$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales3 = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $a43aa20d3eb44e80$var$determineAxis(id, scaleConf);
        const defaultId = $a43aa20d3eb44e80$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales3[id] = (0, $f0bf98aa79b5dc9b$export$7910e0436ed8d1de)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $a43aa20d3eb44e80$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $f0bf98aa79b5dc9b$export$ce26c07117d59d6a)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $a43aa20d3eb44e80$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales3[id] = scales3[id] || Object.create(null);
            (0, $f0bf98aa79b5dc9b$export$7910e0436ed8d1de)(scales3[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales3).forEach((key)=>{
        const scale = scales3[key];
        (0, $f0bf98aa79b5dc9b$export$7910e0436ed8d1de)(scale, [
            (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).scales[scale.type],
            (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).scale
        ]);
    });
    return scales3;
}
function $a43aa20d3eb44e80$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $a43aa20d3eb44e80$var$mergeScaleConfig(config, options);
}
function $a43aa20d3eb44e80$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $a43aa20d3eb44e80$var$initConfig(config) {
    config = config || {};
    config.data = $a43aa20d3eb44e80$var$initData(config.data);
    $a43aa20d3eb44e80$var$initOptions(config);
    return config;
}
const $a43aa20d3eb44e80$var$keyCache = new Map();
const $a43aa20d3eb44e80$var$keysCached = new Set();
function $a43aa20d3eb44e80$var$cachedKeys(cacheKey, generate) {
    let keys = $a43aa20d3eb44e80$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $a43aa20d3eb44e80$var$keyCache.set(cacheKey, keys);
        $a43aa20d3eb44e80$var$keysCached.add(keys);
    }
    return keys;
}
const $a43aa20d3eb44e80$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $f0bf98aa79b5dc9b$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $a43aa20d3eb44e80$var$Config {
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $a43aa20d3eb44e80$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $a43aa20d3eb44e80$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $a43aa20d3eb44e80$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $a43aa20d3eb44e80$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`, 
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $a43aa20d3eb44e80$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $a43aa20d3eb44e80$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || [], 
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options , type: type  } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$a43aa20d3eb44e80$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$a43aa20d3eb44e80$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$a43aa20d3eb44e80$var$addIfFound(scopes, (0, $f0bf98aa79b5dc9b$export$ce26c07117d59d6a)[type] || {}, key));
            keys.forEach((key)=>$a43aa20d3eb44e80$var$addIfFound(scopes, (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$a43aa20d3eb44e80$var$addIfFound(scopes, (0, $f0bf98aa79b5dc9b$export$a8550f7dbe79f93a), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($a43aa20d3eb44e80$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options , type: type  } = this;
        return [
            options,
            (0, $f0bf98aa79b5dc9b$export$ce26c07117d59d6a)[type] || {},
            (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0),
            (0, $f0bf98aa79b5dc9b$export$a8550f7dbe79f93a)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver , subPrefixes: subPrefixes  } = $a43aa20d3eb44e80$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($a43aa20d3eb44e80$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $f0bf98aa79b5dc9b$export$2e2af4578d910ddf)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $f0bf98aa79b5dc9b$export$a93c5207d687da10)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver  } = $a43aa20d3eb44e80$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(context) ? (0, $f0bf98aa79b5dc9b$export$a93c5207d687da10)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
    constructor(config){
        this._config = $a43aa20d3eb44e80$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
}
function $a43aa20d3eb44e80$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $f0bf98aa79b5dc9b$export$c3950d9923825c02)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $a43aa20d3eb44e80$var$hasFunction = (value)=>(0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $f0bf98aa79b5dc9b$export$2e2af4578d910ddf)(value[key]), false);
function $a43aa20d3eb44e80$var$needContext(proxy, names) {
    const { isScriptable: isScriptable , isIndexable: isIndexable  } = (0, $f0bf98aa79b5dc9b$export$a9c996f45e5784d0)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $f0bf98aa79b5dc9b$export$2e2af4578d910ddf)(value) || $a43aa20d3eb44e80$var$hasFunction(value)) || indexable && (0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $a43aa20d3eb44e80$var$version = "3.8.0";
const $a43aa20d3eb44e80$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $a43aa20d3eb44e80$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $a43aa20d3eb44e80$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $a43aa20d3eb44e80$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $a43aa20d3eb44e80$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions1 = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(animationOptions1 && animationOptions1.onComplete, [
        context
    ], chart);
}
function $a43aa20d3eb44e80$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions2 = chart.options.animation;
    (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(animationOptions2 && animationOptions2.onProgress, [
        context
    ], chart);
}
function $a43aa20d3eb44e80$var$getCanvas(item) {
    if ((0, $f0bf98aa79b5dc9b$export$61196ced6d74a310)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $a43aa20d3eb44e80$var$instances = {};
const $a43aa20d3eb44e80$var$getChart = (key)=>{
    const canvas = $a43aa20d3eb44e80$var$getCanvas(key);
    return Object.values($a43aa20d3eb44e80$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $a43aa20d3eb44e80$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $a43aa20d3eb44e80$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
class $a43aa20d3eb44e80$export$acaa6426d77a227e {
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio , maintainAspectRatio: maintainAspectRatio  } , width: width , height: height , _aspectRatio: _aspectRatio  } = this;
        if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $f0bf98aa79b5dc9b$export$4c3d22f3d993c33f)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $f0bf98aa79b5dc9b$export$f787f51d84a910ad)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $a43aa20d3eb44e80$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$a43aa20d3eb44e80$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $f0bf98aa79b5dc9b$export$4c3d22f3d993c33f)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales4 = this.scales;
        const updated = Object.keys(scales4).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $a43aa20d3eb44e80$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $a43aa20d3eb44e80$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $a43aa20d3eb44e80$var$positionIsHorizontal(scaleOptions.position, axis) !== $a43aa20d3eb44e80$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales4 && scales4[id].type === scaleType) scale = scales4[id];
            else {
                const scaleClass = $a43aa20d3eb44e80$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales4[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales4[id];
        });
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(scales4, (scale)=>{
            $a43aa20d3eb44e80$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $a43aa20d3eb44e80$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($a43aa20d3eb44e80$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets , data: { datasets: datasets  }  } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index50)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index50);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $a43aa20d3eb44e80$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $a43aa20d3eb44e80$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType , dataElementType: dataElementType  } = (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $a43aa20d3eb44e80$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $a43aa20d3eb44e80$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller  } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($a43aa20d3eb44e80$var$compare2Level("z", "_idx"));
        const { _active: _active , _lastEvent: _lastEvent  } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this.scales, (scale)=>{
            $a43aa20d3eb44e80$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $f0bf98aa79b5dc9b$export$c9170ad7d4cd7e57)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices  } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method , start: start , count: count  } of changes){
            const move = method === "_removeElements" ? -count : count;
            $a43aa20d3eb44e80$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i4 = 1; i4 < datasetCount; i4++){
            if (!(0, $f0bf98aa79b5dc9b$export$c9170ad7d4cd7e57)(changeSet, makeSet(i4))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index51)=>{
            item._idx = index51;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i5 = 0, ilen1 = this.data.datasets.length; i5 < ilen1; ++i5)this._updateDataset(i5, (0, $f0bf98aa79b5dc9b$export$2e2af4578d910ddf)(mode) ? mode({
            datasetIndex: i5
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index52, mode) {
        const meta = this.getDatasetMeta(index52);
        const args = {
            meta: meta,
            index: index52,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($a43aa20d3eb44e80$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$a43aa20d3eb44e80$export$a424a0aa8f687495.running(this)) $a43aa20d3eb44e80$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $a43aa20d3eb44e80$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width , height: height  } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $f0bf98aa79b5dc9b$export$78acf4525d8a74c4)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $f0bf98aa79b5dc9b$export$dc98b0b04f4c7758)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $f0bf98aa79b5dc9b$export$ef35774e6d314e91)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $a43aa20d3eb44e80$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index53) {
        this._hiddenIndices[index53] = !this._hiddenIndices[index53];
    }
    getDataVisibility(index54) {
        return !this._hiddenIndices[index54];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $f0bf98aa79b5dc9b$export$35e795649ee09318)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $a43aa20d3eb44e80$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas , ctx: ctx  } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $f0bf98aa79b5dc9b$export$f787f51d84a910ad)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins("destroy");
        delete $a43aa20d3eb44e80$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener1 = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this.options.events, (type)=>_add(type, listener1));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener2 = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener2);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener2);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex , index: index55  })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index55],
                index: index55
            };
        });
        const changed = !(0, $f0bf98aa79b5dc9b$export$ee7c8ad385a60b7b)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [] , options: options  } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $f0bf98aa79b5dc9b$export$995eb9fca571757)(e);
        const lastEvent = $a43aa20d3eb44e80$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $f0bf98aa79b5dc9b$export$ee7c8ad385a60b7b)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
    constructor(item, userConfig){
        const config = this.config = new $a43aa20d3eb44e80$var$Config(userConfig);
        const initialCanvas = $a43aa20d3eb44e80$var$getCanvas(item);
        const existingChart = $a43aa20d3eb44e80$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $a43aa20d3eb44e80$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $f0bf98aa79b5dc9b$export$555508cbc6add439)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $a43aa20d3eb44e80$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $f0bf98aa79b5dc9b$export$2219238a014317b0)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $a43aa20d3eb44e80$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $a43aa20d3eb44e80$export$a424a0aa8f687495.listen(this, "complete", $a43aa20d3eb44e80$var$onAnimationsComplete);
        $a43aa20d3eb44e80$export$a424a0aa8f687495.listen(this, "progress", $a43aa20d3eb44e80$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
}
const $a43aa20d3eb44e80$var$invalidatePlugins = ()=>(0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)($a43aa20d3eb44e80$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $a43aa20d3eb44e80$var$enumerable = true;
Object.defineProperties($a43aa20d3eb44e80$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0)
    },
    instances: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: $a43aa20d3eb44e80$var$instances
    },
    overrides: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: (0, $f0bf98aa79b5dc9b$export$ce26c07117d59d6a)
    },
    registry: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: $a43aa20d3eb44e80$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: $a43aa20d3eb44e80$var$version
    },
    getChart: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: $a43aa20d3eb44e80$var$getChart
    },
    register: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: (...items)=>{
            $a43aa20d3eb44e80$export$4bb7493d241fd8a5.add(...items);
            $a43aa20d3eb44e80$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $a43aa20d3eb44e80$var$enumerable,
        value: (...items)=>{
            $a43aa20d3eb44e80$export$4bb7493d241fd8a5.remove(...items);
            $a43aa20d3eb44e80$var$invalidatePlugins();
        }
    }
});
function $a43aa20d3eb44e80$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle , pixelMargin: pixelMargin , x: x , y: y , outerRadius: outerRadius , innerRadius: innerRadius  } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd), startAngle - (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $a43aa20d3eb44e80$var$toRadiusCorners(value) {
    return (0, $f0bf98aa79b5dc9b$export$3b513254972cfc9c)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $a43aa20d3eb44e80$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $a43aa20d3eb44e80$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(o.innerEnd, 0, innerLimit)
    };
}
function $a43aa20d3eb44e80$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $a43aa20d3eb44e80$var$pathArc(ctx, element, offset, spacing, end) {
    const { x: x , y: y , startAngle: start , pixelMargin: pixelMargin , innerRadius: innerR  } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart , outerEnd: outerEnd , innerStart: innerStart , innerEnd: innerEnd  } = $a43aa20d3eb44e80$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
    if (outerEnd > 0) {
        const pCenter = $a43aa20d3eb44e80$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd));
    }
    const p4 = $a43aa20d3eb44e80$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
    ctx.lineTo(p4.x, p4.y);
    if (innerEnd > 0) {
        const pCenter = $a43aa20d3eb44e80$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
    }
    ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
    if (innerStart > 0) {
        const pCenter = $a43aa20d3eb44e80$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd));
    }
    const p8 = $a43aa20d3eb44e80$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
    ctx.lineTo(p8.x, p8.y);
    if (outerStart > 0) {
        const pCenter = $a43aa20d3eb44e80$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
    }
    ctx.closePath();
}
function $a43aa20d3eb44e80$var$drawArc(ctx, element, offset, spacing) {
    const { fullCircles: fullCircles , startAngle: startAngle , circumference: circumference  } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $a43aa20d3eb44e80$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7));
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7);
            if (circumference % (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7) === 0) endAngle += (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7);
        }
    }
    $a43aa20d3eb44e80$var$pathArc(ctx, element, offset, spacing, endAngle);
    ctx.fill();
    return endAngle;
}
function $a43aa20d3eb44e80$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x , y: y , startAngle: startAngle , pixelMargin: pixelMargin , fullCircles: fullCircles  } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $a43aa20d3eb44e80$var$clipArc(ctx, element, startAngle + (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $a43aa20d3eb44e80$var$drawBorder(ctx, element, offset, spacing, endAngle) {
    const { options: options  } = element;
    const { borderWidth: borderWidth , borderJoinStyle: borderJoinStyle  } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    if (element.fullCircles) $a43aa20d3eb44e80$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $a43aa20d3eb44e80$var$clipArc(ctx, element, endAngle);
    $a43aa20d3eb44e80$var$pathArc(ctx, element, offset, spacing, endAngle);
    ctx.stroke();
}
class $a43aa20d3eb44e80$export$d48203c759d6a1fc extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle , distance: distance  } = (0, $f0bf98aa79b5dc9b$export$e7094788287c5e9b)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle , endAngle: endAngle , innerRadius: innerRadius , outerRadius: outerRadius , circumference: circumference  } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7) || (0, $f0bf98aa79b5dc9b$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x , y: y , startAngle: startAngle , endAngle: endAngle , innerRadius: innerRadius , outerRadius: outerRadius  } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference", 
        ], useFinalPosition);
        const { offset: offset , spacing: spacing  } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options , circumference: circumference  } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= (0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $a43aa20d3eb44e80$var$drawArc(ctx, this, radiusOffset, spacing);
        $a43aa20d3eb44e80$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle);
        ctx.restore();
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
}
$a43aa20d3eb44e80$export$d48203c759d6a1fc.id = "arc";
$a43aa20d3eb44e80$export$d48203c759d6a1fc.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined
};
$a43aa20d3eb44e80$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $a43aa20d3eb44e80$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $a43aa20d3eb44e80$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $a43aa20d3eb44e80$var$getLineMethod(options) {
    if (options.stepped) return 0, $f0bf98aa79b5dc9b$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $f0bf98aa79b5dc9b$export$d24c54395ce0c509;
    return $a43aa20d3eb44e80$var$lineTo;
}
function $a43aa20d3eb44e80$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0 , end: paramsEnd = count - 1  } = params;
    const { start: segmentStart , end: segmentEnd  } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $a43aa20d3eb44e80$var$pathSegment(ctx, line, segment, params) {
    const { points: points , options: options  } = line;
    const { count: count , start: start , loop: loop , ilen: ilen  } = $a43aa20d3eb44e80$var$pathVars(points, segment, params);
    const lineMethod = $a43aa20d3eb44e80$var$getLineMethod(options);
    let { move: move = true , reverse: reverse  } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $a43aa20d3eb44e80$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count , start: start , ilen: ilen  } = $a43aa20d3eb44e80$var$pathVars(points, segment, params);
    const { move: move = true , reverse: reverse  } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index56)=>(start + (reverse ? ilen - index56 : index56)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $a43aa20d3eb44e80$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $a43aa20d3eb44e80$var$fastPathSegment : $a43aa20d3eb44e80$var$pathSegment;
}
function $a43aa20d3eb44e80$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $f0bf98aa79b5dc9b$export$306ddfe3a8403e2;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $f0bf98aa79b5dc9b$export$7a38258bbe170828;
    return 0, $f0bf98aa79b5dc9b$export$2f6ca3d3b1f80bf5;
}
function $a43aa20d3eb44e80$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $a43aa20d3eb44e80$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $a43aa20d3eb44e80$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments , options: options  } = line;
    const segmentMethod = $a43aa20d3eb44e80$var$_getSegmentMethod(line);
    for (const segment of segments){
        $a43aa20d3eb44e80$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $a43aa20d3eb44e80$var$usePath2D = typeof Path2D === "function";
function $a43aa20d3eb44e80$var$draw(ctx, line, start, count) {
    if ($a43aa20d3eb44e80$var$usePath2D && !line.options.segment) $a43aa20d3eb44e80$var$strokePathWithCache(ctx, line, start, count);
    else $a43aa20d3eb44e80$var$strokePathDirect(ctx, line, start, count);
}
class $a43aa20d3eb44e80$export$55e463fa7bcd3469 extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $f0bf98aa79b5dc9b$export$21579262ef46735b)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $f0bf98aa79b5dc9b$export$ab83b03e4111b1d0)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $f0bf98aa79b5dc9b$export$1a82df3d29112e01)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $a43aa20d3eb44e80$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start , end: end  } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $a43aa20d3eb44e80$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $a43aa20d3eb44e80$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $a43aa20d3eb44e80$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
$a43aa20d3eb44e80$export$55e463fa7bcd3469.id = "line";
$a43aa20d3eb44e80$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$a43aa20d3eb44e80$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$a43aa20d3eb44e80$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $a43aa20d3eb44e80$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value  } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $a43aa20d3eb44e80$export$bd159b522b230b7a extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x , y: y  } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $a43aa20d3eb44e80$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $a43aa20d3eb44e80$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x , y: y  } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $f0bf98aa79b5dc9b$export$ef35774e6d314e91)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $f0bf98aa79b5dc9b$export$6554612db691658e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
$a43aa20d3eb44e80$export$bd159b522b230b7a.id = "point";
$a43aa20d3eb44e80$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$a43aa20d3eb44e80$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $a43aa20d3eb44e80$var$getBarBounds(bar, useFinalPosition) {
    const { x: x , y: y , base: base , width: width , height: height  } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $a43aa20d3eb44e80$var$skipOrLimit(skip1, value, min, max) {
    return skip1 ? 0 : (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(value, min, max);
}
function $a43aa20d3eb44e80$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip2 = bar.borderSkipped;
    const o = (0, $f0bf98aa79b5dc9b$export$1fbe638ecf81657e)(value);
    return {
        t: $a43aa20d3eb44e80$var$skipOrLimit(skip2.top, o.top, 0, maxH),
        r: $a43aa20d3eb44e80$var$skipOrLimit(skip2.right, o.right, 0, maxW),
        b: $a43aa20d3eb44e80$var$skipOrLimit(skip2.bottom, o.bottom, 0, maxH),
        l: $a43aa20d3eb44e80$var$skipOrLimit(skip2.left, o.left, 0, maxW)
    };
}
function $a43aa20d3eb44e80$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius  } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd)(value);
    const maxR = Math.min(maxW, maxH);
    const skip3 = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $a43aa20d3eb44e80$var$skipOrLimit(!enableBorder || skip3.top || skip3.left, o.topLeft, 0, maxR),
        topRight: $a43aa20d3eb44e80$var$skipOrLimit(!enableBorder || skip3.top || skip3.right, o.topRight, 0, maxR),
        bottomLeft: $a43aa20d3eb44e80$var$skipOrLimit(!enableBorder || skip3.bottom || skip3.left, o.bottomLeft, 0, maxR),
        bottomRight: $a43aa20d3eb44e80$var$skipOrLimit(!enableBorder || skip3.bottom || skip3.right, o.bottomRight, 0, maxR)
    };
}
function $a43aa20d3eb44e80$var$boundingRects(bar) {
    const bounds = $a43aa20d3eb44e80$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $a43aa20d3eb44e80$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $a43aa20d3eb44e80$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $a43aa20d3eb44e80$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $a43aa20d3eb44e80$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(x, bounds.left, bounds.right)) && (skipY || (0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(y, bounds.top, bounds.bottom));
}
function $a43aa20d3eb44e80$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $a43aa20d3eb44e80$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $a43aa20d3eb44e80$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $a43aa20d3eb44e80$export$a16ed71bf4b07672 extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    draw(ctx) {
        const { inflateAmount: inflateAmount , options: { borderColor: borderColor , backgroundColor: backgroundColor  }  } = this;
        const { inner: inner , outer: outer  } = $a43aa20d3eb44e80$var$boundingRects(this);
        const addRectPath = $a43aa20d3eb44e80$var$hasRadius(outer.radius) ? (0, $f0bf98aa79b5dc9b$export$493d36ec626b6698) : $a43aa20d3eb44e80$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $a43aa20d3eb44e80$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $a43aa20d3eb44e80$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $a43aa20d3eb44e80$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $a43aa20d3eb44e80$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $a43aa20d3eb44e80$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $a43aa20d3eb44e80$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x , y: y , base: base , horizontal: horizontal  } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
$a43aa20d3eb44e80$export$a16ed71bf4b07672.id = "bar";
$a43aa20d3eb44e80$export$a16ed71bf4b07672.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: undefined
};
$a43aa20d3eb44e80$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
var $a43aa20d3eb44e80$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $a43aa20d3eb44e80$export$d48203c759d6a1fc,
    LineElement: $a43aa20d3eb44e80$export$55e463fa7bcd3469,
    PointElement: $a43aa20d3eb44e80$export$bd159b522b230b7a,
    BarElement: $a43aa20d3eb44e80$export$a16ed71bf4b07672
});
function $a43aa20d3eb44e80$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx , y: pointAy  } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $a43aa20d3eb44e80$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(minIndex) && !(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $a43aa20d3eb44e80$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $a43aa20d3eb44e80$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $a43aa20d3eb44e80$var$cleanDecimatedDataset(dataset);
    });
}
function $a43aa20d3eb44e80$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale  } = meta;
    const { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = iScale.getUserBounds();
    if (minDefined) start = (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)((0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)((0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $a43aa20d3eb44e80$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $a43aa20d3eb44e80$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data , indexAxis: indexAxis  } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $f0bf98aa79b5dc9b$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start , count: count  } = $a43aa20d3eb44e80$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $a43aa20d3eb44e80$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $a43aa20d3eb44e80$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $a43aa20d3eb44e80$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $a43aa20d3eb44e80$var$cleanDecimatedData(chart);
    }
};
function $a43aa20d3eb44e80$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start , end: end  } = segment;
        end = $a43aa20d3eb44e80$var$_findSegmentEnd(start, end, points);
        const bounds = $a43aa20d3eb44e80$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $f0bf98aa79b5dc9b$export$1a82df3d29112e01)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $a43aa20d3eb44e80$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $f0bf98aa79b5dc9b$export$92108d983e8ee699)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $a43aa20d3eb44e80$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $a43aa20d3eb44e80$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $a43aa20d3eb44e80$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce)(start);
        end = (0, $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $a43aa20d3eb44e80$var$_pointsFromSegments(boundary, line) {
    const { x: x = null , y: y = null  } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start , end: end  })=>{
        end = $a43aa20d3eb44e80$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $a43aa20d3eb44e80$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $a43aa20d3eb44e80$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $a43aa20d3eb44e80$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $a43aa20d3eb44e80$var$_pointsFromSegments(boundary, line);
    return points.length ? new $a43aa20d3eb44e80$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $a43aa20d3eb44e80$var$_resolveTarget(sources, index57, propagate) {
    const source = sources[index57];
    let fill1 = source.fill;
    const visited = [
        index57
    ];
    let target;
    if (!propagate) return fill1;
    while(fill1 !== false && visited.indexOf(fill1) === -1){
        if (!(0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(fill1)) return fill1;
        target = sources[fill1];
        if (!target) return false;
        if (target.visible) return fill1;
        visited.push(fill1);
        fill1 = target.fill;
    }
    return false;
}
function $a43aa20d3eb44e80$var$_decodeFill(line, index58, count) {
    const fill2 = $a43aa20d3eb44e80$var$parseFillOption(line);
    if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(fill2)) return isNaN(fill2.value) ? false : fill2;
    let target = parseFloat(fill2);
    if ((0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $a43aa20d3eb44e80$var$decodeTargetIndex(fill2[0], index58, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill2) >= 0 && fill2;
}
function $a43aa20d3eb44e80$var$decodeTargetIndex(firstCh, index59, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index59 + target;
    if (target === index59 || target < 0 || target >= count) return false;
    return target;
}
function $a43aa20d3eb44e80$var$_getTargetPixel(fill3, scale) {
    let pixel = null;
    if (fill3 === "start") pixel = scale.bottom;
    else if (fill3 === "end") pixel = scale.top;
    else if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(fill3)) pixel = scale.getPixelForValue(fill3.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $a43aa20d3eb44e80$var$_getTargetValue(fill4, scale, startValue) {
    let value;
    if (fill4 === "start") value = startValue;
    else if (fill4 === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $f0bf98aa79b5dc9b$export$23f2a1d2818174ef)(fill4)) value = fill4.value;
    else value = scale.getBaseValue();
    return value;
}
function $a43aa20d3eb44e80$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill5 = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill5 === undefined) fill5 = !!options.backgroundColor;
    if (fill5 === false || fill5 === null) return false;
    if (fill5 === true) return "origin";
    return fill5;
}
function $a43aa20d3eb44e80$var$_buildStackLine(source) {
    const { scale: scale , index: index60 , line: line  } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $a43aa20d3eb44e80$var$getLinesBelow(scale, index60);
    linesBelow.push($a43aa20d3eb44e80$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$a43aa20d3eb44e80$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $a43aa20d3eb44e80$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $a43aa20d3eb44e80$var$getLinesBelow(scale, index61) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index61) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $a43aa20d3eb44e80$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first , last: last , point: point  } = $a43aa20d3eb44e80$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $a43aa20d3eb44e80$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $a43aa20d3eb44e80$var$simpleArc {
    pathSegment(ctx, bounds, opts) {
        const { x: x , y: y , radius: radius  } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x , y: y , radius: radius  } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
}
function $a43aa20d3eb44e80$var$_getTarget(source) {
    const { chart: chart , fill: fill6 , line: line  } = source;
    if ((0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(fill6)) return $a43aa20d3eb44e80$var$getLineByIndex(chart, fill6);
    if (fill6 === "stack") return $a43aa20d3eb44e80$var$_buildStackLine(source);
    if (fill6 === "shape") return true;
    const boundary = $a43aa20d3eb44e80$var$computeBoundary(source);
    if (boundary instanceof $a43aa20d3eb44e80$var$simpleArc) return boundary;
    return $a43aa20d3eb44e80$var$_createBoundaryLine(boundary, line);
}
function $a43aa20d3eb44e80$var$getLineByIndex(chart, index62) {
    const meta = chart.getDatasetMeta(index62);
    const visible = meta && chart.isDatasetVisible(index62);
    return visible ? meta.dataset : null;
}
function $a43aa20d3eb44e80$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $a43aa20d3eb44e80$var$computeCircularBoundary(source);
    return $a43aa20d3eb44e80$var$computeLinearBoundary(source);
}
function $a43aa20d3eb44e80$var$computeLinearBoundary(source) {
    const { scale: scale = {} , fill: fill7  } = source;
    const pixel = $a43aa20d3eb44e80$var$_getTargetPixel(fill7, scale);
    if ((0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $a43aa20d3eb44e80$var$computeCircularBoundary(source) {
    const { scale: scale , fill: fill8  } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $a43aa20d3eb44e80$var$_getTargetValue(fill8, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $a43aa20d3eb44e80$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $a43aa20d3eb44e80$var$_drawfill(ctx, source, area) {
    const target = $a43aa20d3eb44e80$var$_getTarget(source);
    const { line: line , scale: scale , axis: axis  } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color2 = lineOpts.backgroundColor;
    const { above: above = color2 , below: below = color2  } = fillOption || {};
    if (target && line.points.length) {
        (0, $f0bf98aa79b5dc9b$export$78acf4525d8a74c4)(ctx, area);
        $a43aa20d3eb44e80$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $f0bf98aa79b5dc9b$export$dc98b0b04f4c7758)(ctx);
    }
}
function $a43aa20d3eb44e80$var$doFill(ctx, cfg) {
    const { line: line , target: target , above: above , below: below , area: area , scale: scale  } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $a43aa20d3eb44e80$var$clipVertical(ctx, target, area.top);
        $a43aa20d3eb44e80$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $a43aa20d3eb44e80$var$clipVertical(ctx, target, area.bottom);
    }
    $a43aa20d3eb44e80$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $a43aa20d3eb44e80$var$clipVertical(ctx, target, clipY) {
    const { segments: segments , points: points  } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start , end: end  } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$a43aa20d3eb44e80$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $a43aa20d3eb44e80$var$fill(ctx, cfg) {
    const { line: line , target: target , property: property , color: color3 , scale: scale  } = cfg;
    const segments = $a43aa20d3eb44e80$var$_segments(line, target, property);
    for (const { source: src , target: tgt , start: start , end: end  } of segments){
        const { style: { backgroundColor: backgroundColor = color3  } = {}  } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $a43aa20d3eb44e80$var$clipBounds(ctx, scale, notShape && $a43aa20d3eb44e80$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $a43aa20d3eb44e80$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $a43aa20d3eb44e80$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $a43aa20d3eb44e80$var$clipBounds(ctx, scale, bounds) {
    const { top: top , bottom: bottom  } = scale.chart.chartArea;
    const { property: property , start: start , end: end  } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $a43aa20d3eb44e80$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $a43aa20d3eb44e80$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $a43aa20d3eb44e80$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $a43aa20d3eb44e80$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $a43aa20d3eb44e80$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw2 = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw2) $a43aa20d3eb44e80$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (source) $a43aa20d3eb44e80$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!source || source.fill === false || options.drawTime !== "beforeDatasetDraw") return;
        $a43aa20d3eb44e80$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $a43aa20d3eb44e80$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize , boxWidth: boxWidth = fontSize  } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $a43aa20d3eb44e80$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $a43aa20d3eb44e80$var$Legend extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options , ctx: ctx  } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth , itemHeight: itemHeight  } = $a43aa20d3eb44e80$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx , maxWidth: maxWidth , options: { labels: { padding: padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx , maxHeight: maxHeight , options: { labels: { padding: padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes , options: { align: align , labels: { padding: padding  } , rtl: rtl  }  } = this;
        const rtlHelper = (0, $f0bf98aa79b5dc9b$export$28f7fcd39efa255)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $f0bf98aa79b5dc9b$export$78acf4525d8a74c4)(ctx, this);
            this._draw();
            (0, $f0bf98aa79b5dc9b$export$dc98b0b04f4c7758)(ctx);
        }
    }
    _draw() {
        const { options: opts , columnSizes: columnSizes , lineWidths: lineWidths , ctx: ctx  } = this;
        const { align: align , labels: labelOpts  } = opts;
        const defaultColor = (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $f0bf98aa79b5dc9b$export$28f7fcd39efa255)(opts.rtl, this.left, this.width);
        const labelFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(labelOpts.font);
        const { color: fontColor , padding: padding  } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth , boxHeight: boxHeight , itemHeight: itemHeight  } = $a43aa20d3eb44e80$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxWidth * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $f0bf98aa79b5dc9b$export$6554612db691658e)(ctx, drawOptions, centerX, centerY);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $f0bf98aa79b5dc9b$export$493d36ec626b6698)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $f0bf98aa79b5dc9b$export$8743009a87fcb00f)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $f0bf98aa79b5dc9b$export$3d12bd131bb975d1)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $f0bf98aa79b5dc9b$export$91c6e00c14e7e6fd)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $f0bf98aa79b5dc9b$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(titleOpts.font);
        const titlePadding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $f0bf98aa79b5dc9b$export$28f7fcd39efa255)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $f0bf98aa79b5dc9b$export$34aec0b863436764)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $f0bf98aa79b5dc9b$export$8743009a87fcb00f)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(titleOpts.font);
        const titlePadding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(x, this.left, this.right) && (0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $f0bf98aa79b5dc9b$export$f38c853ae54ed474)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$a43aa20d3eb44e80$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $a43aa20d3eb44e80$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $a43aa20d3eb44e80$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $a43aa20d3eb44e80$export$ed247974535929c7 = {
    id: "legend",
    _element: $a43aa20d3eb44e80$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $a43aa20d3eb44e80$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index63 = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index63)) {
                ci.hide(index63);
                legendItem.hidden = true;
            } else {
                ci.show(index63);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle , pointStyle: pointStyle , textAlign: textAlign , color: color4  }  } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color4,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $a43aa20d3eb44e80$var$Title extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(opts.padding);
        const textSize = lineCount * (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top , left: left , bottom: bottom , right: right , options: options  } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, bottom, top);
                rotation = (0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $f0bf98aa79b5dc9b$export$3c2fa207a37baaea)(align, top, bottom);
                rotation = (0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX , titleY: titleY , maxWidth: maxWidth , rotation: rotation  } = this._drawArgs(offset);
        (0, $f0bf98aa79b5dc9b$export$8743009a87fcb00f)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $f0bf98aa79b5dc9b$export$34aec0b863436764)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $a43aa20d3eb44e80$var$createTitle(chart, titleOpts) {
    const title = new $a43aa20d3eb44e80$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $a43aa20d3eb44e80$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $a43aa20d3eb44e80$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $a43aa20d3eb44e80$export$f99233281efd08a0 = {
    id: "title",
    _element: $a43aa20d3eb44e80$var$Title,
    start (chart, _args, options) {
        $a43aa20d3eb44e80$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $a43aa20d3eb44e80$var$map = new WeakMap();
var $a43aa20d3eb44e80$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $a43aa20d3eb44e80$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.configure(chart, title, options);
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.addBox(chart, title);
        $a43aa20d3eb44e80$var$map.set(chart, title);
    },
    stop (chart) {
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.removeBox(chart, $a43aa20d3eb44e80$var$map.get(chart));
        $a43aa20d3eb44e80$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $a43aa20d3eb44e80$var$map.get(chart);
        $a43aa20d3eb44e80$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $a43aa20d3eb44e80$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $f0bf98aa79b5dc9b$export$24baa2b76016ce0e)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $a43aa20d3eb44e80$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $a43aa20d3eb44e80$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $a43aa20d3eb44e80$var$createTooltipItem(chart, item) {
    const { element: element , datasetIndex: datasetIndex , index: index64  } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label , value: value  } = controller.getLabelAndValue(index64);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index64),
        raw: chart.data.datasets[datasetIndex].data[index64],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index64,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $a43aa20d3eb44e80$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body , footer: footer , title: title  } = tooltip;
    const { boxWidth: boxWidth , boxHeight: boxHeight  } = options;
    const bodyFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.bodyFont);
    const titleFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.titleFont);
    const footerFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(body, (bodyItem)=>{
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(bodyItem.before, maxLineWidth);
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(bodyItem.lines, maxLineWidth);
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $a43aa20d3eb44e80$var$determineYAlign(chart, size) {
    const { y: y , height: height  } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $a43aa20d3eb44e80$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x , width: width  } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $a43aa20d3eb44e80$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x , width: width  } = size;
    const { width: chartWidth , chartArea: { left: left , right: right  }  } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($a43aa20d3eb44e80$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $a43aa20d3eb44e80$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $a43aa20d3eb44e80$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $a43aa20d3eb44e80$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $a43aa20d3eb44e80$var$alignX(size, xAlign) {
    let { x: x , width: width  } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $a43aa20d3eb44e80$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y , height: height  } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $a43aa20d3eb44e80$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize , caretPadding: caretPadding , cornerRadius: cornerRadius  } = options;
    const { xAlign: xAlign , yAlign: yAlign  } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft , topRight: topRight , bottomLeft: bottomLeft , bottomRight: bottomRight  } = (0, $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd)(cornerRadius);
    let x = $a43aa20d3eb44e80$var$alignX(size, xAlign);
    const y = $a43aa20d3eb44e80$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(x, 0, chart.width - size.width),
        y: (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(y, 0, chart.height - size.height)
    };
}
function $a43aa20d3eb44e80$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $a43aa20d3eb44e80$var$getBeforeAfterBodyLines(callback1) {
    return $a43aa20d3eb44e80$var$pushOrConcat([], $a43aa20d3eb44e80$var$splitNewlines(callback1));
}
function $a43aa20d3eb44e80$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $a43aa20d3eb44e80$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $a43aa20d3eb44e80$var$Tooltip extends $a43aa20d3eb44e80$export$db77ccec0bb4ccac {
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $a43aa20d3eb44e80$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $a43aa20d3eb44e80$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks  } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $a43aa20d3eb44e80$var$pushOrConcat(lines, $a43aa20d3eb44e80$var$splitNewlines(beforeTitle));
        lines = $a43aa20d3eb44e80$var$pushOrConcat(lines, $a43aa20d3eb44e80$var$splitNewlines(title));
        lines = $a43aa20d3eb44e80$var$pushOrConcat(lines, $a43aa20d3eb44e80$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $a43aa20d3eb44e80$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks  } = options;
        const bodyItems = [];
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $a43aa20d3eb44e80$var$overrideCallbacks(callbacks, context);
            $a43aa20d3eb44e80$var$pushOrConcat(bodyItem.before, $a43aa20d3eb44e80$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $a43aa20d3eb44e80$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $a43aa20d3eb44e80$var$pushOrConcat(bodyItem.after, $a43aa20d3eb44e80$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $a43aa20d3eb44e80$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks  } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $a43aa20d3eb44e80$var$pushOrConcat(lines, $a43aa20d3eb44e80$var$splitNewlines(beforeFooter));
        lines = $a43aa20d3eb44e80$var$pushOrConcat(lines, $a43aa20d3eb44e80$var$splitNewlines(footer));
        lines = $a43aa20d3eb44e80$var$pushOrConcat(lines, $a43aa20d3eb44e80$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($a43aa20d3eb44e80$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index65, array)=>options.filter(element, index65, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(tooltipItems, (context)=>{
            const scoped = $a43aa20d3eb44e80$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $a43aa20d3eb44e80$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $a43aa20d3eb44e80$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $a43aa20d3eb44e80$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $a43aa20d3eb44e80$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign , yAlign: yAlign  } = this;
        const { caretSize: caretSize , cornerRadius: cornerRadius  } = options;
        const { topLeft: topLeft , topRight: topRight , bottomLeft: bottomLeft , bottomRight: bottomRight  } = (0, $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd)(cornerRadius);
        const { x: ptX , y: ptY  } = tooltipPoint;
        const { width: width , height: height  } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $f0bf98aa79b5dc9b$export$28f7fcd39efa255)(options.rtl, this.x, this.width);
            pt.x = $a43aa20d3eb44e80$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight , boxWidth: boxWidth , boxPadding: boxPadding  } = options;
        const bodyFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.bodyFont);
        const colorX = $a43aa20d3eb44e80$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $f0bf98aa79b5dc9b$export$6554612db691658e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $f0bf98aa79b5dc9b$export$6554612db691658e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $f0bf98aa79b5dc9b$export$493d36ec626b6698)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $f0bf98aa79b5dc9b$export$493d36ec626b6698)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body  } = this;
        const { bodySpacing: bodySpacing , bodyAlign: bodyAlign , displayColors: displayColors , boxHeight: boxHeight , boxWidth: boxWidth , boxPadding: boxPadding  } = options;
        const bodyFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $f0bf98aa79b5dc9b$export$28f7fcd39efa255)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $a43aa20d3eb44e80$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $f0bf98aa79b5dc9b$export$a9c23c6ac3fc3eca)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $f0bf98aa79b5dc9b$export$28f7fcd39efa255)(options.rtl, this.x, this.width);
            pt.x = $a43aa20d3eb44e80$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign , yAlign: yAlign  } = this;
        const { x: x , y: y  } = pt;
        const { width: width , height: height  } = tooltipSize;
        const { topLeft: topLeft , topRight: topRight , bottomLeft: bottomLeft , bottomRight: bottomRight  } = (0, $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $a43aa20d3eb44e80$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $a43aa20d3eb44e80$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $a43aa20d3eb44e80$var$determineAlignment(chart, options, positionAndSize);
            const point = $a43aa20d3eb44e80$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $f0bf98aa79b5dc9b$export$3d12bd131bb975d1)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $f0bf98aa79b5dc9b$export$9d398bebfec1c039)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex , index: index66  })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index66],
                index: index66
            };
        });
        const changed = !(0, $f0bf98aa79b5dc9b$export$ee7c8ad385a60b7b)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $f0bf98aa79b5dc9b$export$ee7c8ad385a60b7b)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX , caretY: caretY , options: options  } = this;
        const position = $a43aa20d3eb44e80$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
}
$a43aa20d3eb44e80$var$Tooltip.positioners = $a43aa20d3eb44e80$var$positioners;
var $a43aa20d3eb44e80$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $a43aa20d3eb44e80$var$Tooltip,
    positioners: $a43aa20d3eb44e80$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $a43aa20d3eb44e80$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            beforeBody: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            beforeLabel: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            afterBody: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            beforeFooter: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            footer: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7),
            afterFooter: (0, $f0bf98aa79b5dc9b$export$890c4ad488842ce7)
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $a43aa20d3eb44e80$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $a43aa20d3eb44e80$export$be17f937e9aa7533,
    Filler: $a43aa20d3eb44e80$export$d19ba4d812bed757,
    Legend: $a43aa20d3eb44e80$export$ed247974535929c7,
    SubTitle: $a43aa20d3eb44e80$export$d5c56664638992a4,
    Title: $a43aa20d3eb44e80$export$f99233281efd08a0,
    Tooltip: $a43aa20d3eb44e80$export$28c660c63b792dea
});
const $a43aa20d3eb44e80$var$addIfString = (labels, raw, index67, addedLabels)=>{
    if (typeof raw === "string") {
        index67 = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index67,
            label: raw
        });
    } else if (isNaN(raw)) index67 = null;
    return index67;
};
function $a43aa20d3eb44e80$var$findOrAddLabel(labels, raw, index68, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $a43aa20d3eb44e80$var$addIfString(labels, raw, index68, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index68 : first;
}
const $a43aa20d3eb44e80$var$validIndex = (index69, max)=>index69 === null ? null : (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(Math.round(index69), 0, max);
class $a43aa20d3eb44e80$export$29e663ba4d09fe7 extends $a43aa20d3eb44e80$export$d60cfc58d3c358b6 {
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index70 , label: label  } of added)if (labels[index70] === label) labels.splice(index70, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index71) {
        if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index71 = isFinite(index71) && labels[index71] === raw ? index71 : $a43aa20d3eb44e80$var$findOrAddLabel(labels, raw, (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(index71, raw), this._addedLabels);
        return $a43aa20d3eb44e80$var$validIndex(index71, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let { min: min , max: max  } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index72) {
        const ticks = this.ticks;
        if (index72 < 0 || index72 > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index72].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
}
$a43aa20d3eb44e80$export$29e663ba4d09fe7.id = "category";
$a43aa20d3eb44e80$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $a43aa20d3eb44e80$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $a43aa20d3eb44e80$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds , step: step , min: min , max: max , precision: precision , count: count , maxTicks: maxTicks , maxDigits: maxDigits , includeBounds: includeBounds  } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin , max: rmax  } = dataRange;
    const minDefined = !(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $f0bf98aa79b5dc9b$export$cf2f7c5792f80b46)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $f0bf98aa79b5dc9b$export$cf2f7c5792f80b46)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $f0bf98aa79b5dc9b$export$53a70dd1ebbae346)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $f0bf98aa79b5dc9b$export$a33b77bbdbb8366c)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $f0bf98aa79b5dc9b$export$b9a6b53f9be3734)(spacing), (0, $f0bf98aa79b5dc9b$export$b9a6b53f9be3734)(niceMin));
    factor = Math.pow(10, (0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $f0bf98aa79b5dc9b$export$a33b77bbdbb8366c)(Math.round((niceMin + j * spacing) * factor) / factor, min, $a43aa20d3eb44e80$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $f0bf98aa79b5dc9b$export$a33b77bbdbb8366c)(ticks[ticks.length - 1].value, max, $a43aa20d3eb44e80$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $a43aa20d3eb44e80$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal , minRotation: minRotation  }) {
    const rad = (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $a43aa20d3eb44e80$var$LinearScaleBase extends $a43aa20d3eb44e80$export$d60cfc58d3c358b6 {
    parse(raw, index) {
        if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero  } = this.options;
        const { minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let { min: min , max: max  } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $f0bf98aa79b5dc9b$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit , stepSize: stepSize  } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $a43aa20d3eb44e80$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $f0bf98aa79b5dc9b$export$158acd800e1ef08b)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $f0bf98aa79b5dc9b$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
}
class $a43aa20d3eb44e80$export$e7f4e5e8656f0b93 extends $a43aa20d3eb44e80$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min , max: max  } = this.getMinMax(true);
        this.min = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$a43aa20d3eb44e80$export$e7f4e5e8656f0b93.id = "linear";
$a43aa20d3eb44e80$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $a43aa20d3eb44e80$export$27c7467594ef87bd.formatters.numeric
    }
};
function $a43aa20d3eb44e80$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(tickVal)));
    return remain === 1;
}
function $a43aa20d3eb44e80$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(generationOptions.min, Math.pow(10, Math.floor((0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(dataRange.min))));
    let exp = Math.floor((0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $a43aa20d3eb44e80$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $f0bf98aa79b5dc9b$export$c4ce752e73470fba)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $a43aa20d3eb44e80$var$isMajor(tickVal)
    });
    return ticks;
}
class $a43aa20d3eb44e80$export$85295eaf7cb3ac3e extends $a43aa20d3eb44e80$export$d60cfc58d3c358b6 {
    parse(raw, index73) {
        const value = $a43aa20d3eb44e80$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index73
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min , max: max  } = this.getMinMax(true);
        this.min = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $a43aa20d3eb44e80$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $f0bf98aa79b5dc9b$export$158acd800e1ef08b)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $f0bf98aa79b5dc9b$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(start);
        this._valueRange = (0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(this.max) - (0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $f0bf98aa79b5dc9b$export$3a1a48c8f6ef640e)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
}
$a43aa20d3eb44e80$export$85295eaf7cb3ac3e.id = "logarithmic";
$a43aa20d3eb44e80$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $a43aa20d3eb44e80$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $a43aa20d3eb44e80$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(tickOpts.backdropPadding);
        return (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $f0bf98aa79b5dc9b$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $a43aa20d3eb44e80$var$measureLabelSize(ctx, font, label) {
    label = (0, $f0bf98aa79b5dc9b$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $f0bf98aa79b5dc9b$export$a05254e7c3aeba6e)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $a43aa20d3eb44e80$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $a43aa20d3eb44e80$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(opts.font);
        const textSize = $a43aa20d3eb44e80$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $f0bf98aa79b5dc9b$export$25ce5a424b770e84)(angleRadians));
        const hLimits = $a43aa20d3eb44e80$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $a43aa20d3eb44e80$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $a43aa20d3eb44e80$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $a43aa20d3eb44e80$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $a43aa20d3eb44e80$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $a43aa20d3eb44e80$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $a43aa20d3eb44e80$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $f0bf98aa79b5dc9b$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $f0bf98aa79b5dc9b$export$25ce5a424b770e84)((0, $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce)(pointLabelPosition.angle + (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd))));
        const size = labelSizes[i];
        const y = $a43aa20d3eb44e80$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $a43aa20d3eb44e80$var$getTextAlignForAngle(angle);
        const left = $a43aa20d3eb44e80$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $a43aa20d3eb44e80$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $a43aa20d3eb44e80$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $a43aa20d3eb44e80$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $a43aa20d3eb44e80$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx , options: { pointLabels: pointLabels  }  } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(optsAtIndex.font);
        const { x: x , y: y , textAlign: textAlign , left: left , top: top , right: right , bottom: bottom  } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor  } = optsAtIndex;
        if (!(0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(backdropColor)) {
            const borderRadius = (0, $f0bf98aa79b5dc9b$export$d66dc83d8cfc8dd)(optsAtIndex.borderRadius);
            const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $f0bf98aa79b5dc9b$export$493d36ec626b6698)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $f0bf98aa79b5dc9b$export$8743009a87fcb00f)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $a43aa20d3eb44e80$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx  } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $a43aa20d3eb44e80$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color5 , lineWidth: lineWidth  } = gridLineOpts;
    if (!circular && !labelCount || !color5 || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color5;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $a43aa20d3eb44e80$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $a43aa20d3eb44e80$var$createPointLabelContext(parent, index74, label) {
    return (0, $f0bf98aa79b5dc9b$export$dda1d9f60106f0e9)(parent, {
        label: label,
        index: index74,
        type: "pointLabel"
    });
}
class $a43aa20d3eb44e80$export$cfafc36d95386d38 extends $a43aa20d3eb44e80$var$LinearScaleBase {
    setDimensions() {
        const padding = this._padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)($a43aa20d3eb44e80$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min , max: max  } = this.getMinMax(false);
        this.min = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $a43aa20d3eb44e80$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $a43aa20d3eb44e80$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index75)=>{
            const label = (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index75
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $a43aa20d3eb44e80$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index76) {
        const angleMultiplier = (0, $f0bf98aa79b5dc9b$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $f0bf98aa79b5dc9b$export$9fa96a7d116ea3ce)(index76 * angleMultiplier + (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index77) {
        const pointLabels = this._pointLabels || [];
        if (index77 >= 0 && index77 < pointLabels.length) {
            const pointLabel = pointLabels[index77];
            return $a43aa20d3eb44e80$var$createPointLabelContext(this.getContext(), index77, pointLabel);
        }
    }
    getPointPosition(index78, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index78) - (0, $f0bf98aa79b5dc9b$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index79, value) {
        return this.getPointPosition(index79, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index80) {
        return this.getPointPositionForValue(index80 || 0, this.getBaseValue());
    }
    getPointLabelPosition(index81) {
        const { left: left , top: top , right: right , bottom: bottom  } = this._pointLabelItems[index81];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor , grid: { circular: circular  }  } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $a43aa20d3eb44e80$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines , grid: grid  } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $a43aa20d3eb44e80$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index82)=>{
            if (index82 !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index82 - 1));
                $a43aa20d3eb44e80$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color6 , lineWidth: lineWidth  } = optsAtIndex;
                if (!lineWidth || !color6) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color6;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index83)=>{
            if (index83 === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index83));
            const tickFont = (0, $f0bf98aa79b5dc9b$export$3d8c2f653ac9d0b9)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index83].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $f0bf98aa79b5dc9b$export$96f57966bedc81b4)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $f0bf98aa79b5dc9b$export$8743009a87fcb00f)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
}
$a43aa20d3eb44e80$export$cfafc36d95386d38.id = "radialLinear";
$a43aa20d3eb44e80$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $a43aa20d3eb44e80$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$a43aa20d3eb44e80$export$cfafc36d95386d38.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$a43aa20d3eb44e80$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $a43aa20d3eb44e80$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $a43aa20d3eb44e80$var$UNITS = Object.keys($a43aa20d3eb44e80$var$INTERVALS);
function $a43aa20d3eb44e80$var$sorter(a, b) {
    return a - b;
}
function $a43aa20d3eb44e80$var$parse(scale, input) {
    if ((0, $f0bf98aa79b5dc9b$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser , round: round , isoWeekday: isoWeekday  } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $f0bf98aa79b5dc9b$export$9e5f44173e64f162)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $a43aa20d3eb44e80$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $a43aa20d3eb44e80$var$UNITS.length;
    for(let i = $a43aa20d3eb44e80$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $a43aa20d3eb44e80$var$INTERVALS[$a43aa20d3eb44e80$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $a43aa20d3eb44e80$var$UNITS[i];
    }
    return $a43aa20d3eb44e80$var$UNITS[ilen - 1];
}
function $a43aa20d3eb44e80$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $a43aa20d3eb44e80$var$UNITS.length - 1; i >= $a43aa20d3eb44e80$var$UNITS.indexOf(minUnit); i--){
        const unit = $a43aa20d3eb44e80$var$UNITS[i];
        if ($a43aa20d3eb44e80$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $a43aa20d3eb44e80$var$UNITS[minUnit ? $a43aa20d3eb44e80$var$UNITS.indexOf(minUnit) : 0];
}
function $a43aa20d3eb44e80$var$determineMajorUnit(unit) {
    for(let i = $a43aa20d3eb44e80$var$UNITS.indexOf(unit) + 1, ilen = $a43aa20d3eb44e80$var$UNITS.length; i < ilen; ++i){
        if ($a43aa20d3eb44e80$var$INTERVALS[$a43aa20d3eb44e80$var$UNITS[i]].common) return $a43aa20d3eb44e80$var$UNITS[i];
    }
}
function $a43aa20d3eb44e80$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo , hi: hi  } = (0, $f0bf98aa79b5dc9b$export$91477dc880baac21)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $a43aa20d3eb44e80$var$setMajorTicks(scale, ticks, map1, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index84;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index84 = map1[major];
        if (index84 >= 0) ticks[index84].major = true;
    }
    return ticks;
}
function $a43aa20d3eb44e80$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map2 = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map2[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $a43aa20d3eb44e80$var$setMajorTicks(scale, ticks, map2, majorUnit);
}
class $a43aa20d3eb44e80$export$a894c72689ff3ec extends $a43aa20d3eb44e80$export$d60cfc58d3c358b6 {
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $a43aa20d3eb44e80$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        (0, $f0bf98aa79b5dc9b$export$7910e0436ed8d1de)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $a43aa20d3eb44e80$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $f0bf98aa79b5dc9b$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $f0bf98aa79b5dc9b$export$23ebac1979863676)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $a43aa20d3eb44e80$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $a43aa20d3eb44e80$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $a43aa20d3eb44e80$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $a43aa20d3eb44e80$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(start, 0, limit);
        end = (0, $f0bf98aa79b5dc9b$export$efccba1c4a2ef57b)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $a43aa20d3eb44e80$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $f0bf98aa79b5dc9b$export$90a7f3efeed30595)(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $f0bf98aa79b5dc9b$export$9e5f44173e64f162)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$a43aa20d3eb44e80$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $a43aa20d3eb44e80$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index85, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index85];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $f0bf98aa79b5dc9b$export$3722cfe417b6ed86)(formatter, [
            label,
            index85,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $f0bf98aa79b5dc9b$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $a43aa20d3eb44e80$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($a43aa20d3eb44e80$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $f0bf98aa79b5dc9b$export$71511d61b312f219)(values.sort($a43aa20d3eb44e80$var$sorter));
    }
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
}
$a43aa20d3eb44e80$export$a894c72689ff3ec.id = "time";
$a43aa20d3eb44e80$export$a894c72689ff3ec.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $a43aa20d3eb44e80$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo , hi: hi  } = (0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(table, "pos", val));
        ({ pos: prevSource , time: prevTarget  } = table[lo]);
        ({ pos: nextSource , time: nextTarget  } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo , hi: hi  } = (0, $f0bf98aa79b5dc9b$export$d141bba7fdc215a3)(table, "time", val));
        ({ time: prevSource , pos: prevTarget  } = table[lo]);
        ({ time: nextSource , pos: nextTarget  } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $a43aa20d3eb44e80$export$85df64a8eb6dc986 extends $a43aa20d3eb44e80$export$a894c72689ff3ec {
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $a43aa20d3eb44e80$var$interpolate(table, this.min);
        this._tableRange = $a43aa20d3eb44e80$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min , max: max  } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($a43aa20d3eb44e80$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $a43aa20d3eb44e80$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
}
$a43aa20d3eb44e80$export$85df64a8eb6dc986.id = "timeseries";
$a43aa20d3eb44e80$export$85df64a8eb6dc986.defaults = $a43aa20d3eb44e80$export$a894c72689ff3ec.defaults;
var $a43aa20d3eb44e80$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $a43aa20d3eb44e80$export$29e663ba4d09fe7,
    LinearScale: $a43aa20d3eb44e80$export$e7f4e5e8656f0b93,
    LogarithmicScale: $a43aa20d3eb44e80$export$85295eaf7cb3ac3e,
    RadialLinearScale: $a43aa20d3eb44e80$export$cfafc36d95386d38,
    TimeScale: $a43aa20d3eb44e80$export$a894c72689ff3ec,
    TimeSeriesScale: $a43aa20d3eb44e80$export$85df64a8eb6dc986
});
const $a43aa20d3eb44e80$export$e8959e79e3af550f = [
    $a43aa20d3eb44e80$export$a6506504f799c5d5,
    $a43aa20d3eb44e80$export$7a5d735b2ab6389d,
    $a43aa20d3eb44e80$export$8b3ca321c77fdea6,
    $a43aa20d3eb44e80$export$bcac1c16f1530ec2, 
];


(0, $a43aa20d3eb44e80$export$acaa6426d77a227e).register((0, $a43aa20d3eb44e80$export$d48203c759d6a1fc), (0, $a43aa20d3eb44e80$export$e04603e7d8b77172), (0, $a43aa20d3eb44e80$export$28c660c63b792dea));
// VIEW
// mortgage amount - сумма ипотеки
const $c373a14459b79063$var$renderMortgageAmount = (elements, watchedState)=>{
    const { resultMortgageAmount: resultMortgageAmount  } = elements;
    const { result: result  } = watchedState;
    if (resultMortgageAmount) resultMortgageAmount.innerHTML = result["mortgage-amount"].toLocaleString("en-US", {
        minimumFractionDigits: 2
    });
};
// monthly payment - ежемесячный платеж
const $c373a14459b79063$var$renderMonthlyPayment = (elements, watchedState)=>{
    const { resultMonthlyPayment: resultMonthlyPayment  } = elements;
    const { result: result  } = watchedState;
    if (resultMonthlyPayment) resultMonthlyPayment.innerHTML = result["monthly-payment"].toLocaleString("en-US", {
        minimumFractionDigits: 2
    });
};
// total cost - общая ипотека
const $c373a14459b79063$var$renderTotalCost = (elements, watchedState)=>{
    const { resultTotalCost: resultTotalCost  } = elements;
    const { result: result  } = watchedState;
    if (resultTotalCost) resultTotalCost.innerHTML = result["mortgage-total-cost"].toLocaleString("en-US", {
        minimumFractionDigits: 2
    });
};
// render donut
const $c373a14459b79063$var$renderDonutChart = (elements, watchedState)=>{
    const { donutBox: donutBox  } = elements;
    const { donutData: donutData  } = watchedState;
    const allDataForChart = donutData.filter((item)=>{
        const { data: data  } = item;
        if (data) return item;
        return 0;
    });
    const chartLabels = allDataForChart.map(({ name: name  })=>name);
    const chartData = allDataForChart.map(({ data: data  })=>data);
    const chartColors = allDataForChart.map(({ color: color  })=>color);
    const donutConfigData = {
        labels: chartLabels,
        datasets: [
            {
                data: chartData,
                backgroundColor: chartColors,
                borderRadius: 5,
                spacing: 5,
                hoverOffset: 3
            }
        ]
    };
    const config = {
        type: "doughnut",
        data: donutConfigData,
        options: []
    };
    const chartStatus = (0, $a43aa20d3eb44e80$export$acaa6426d77a227e).getChart(donutBox);
    if (chartStatus !== undefined) chartStatus.destroy();
    new (0, $a43aa20d3eb44e80$export$acaa6426d77a227e)(donutBox, config);
};
const $c373a14459b79063$export$b3890eb0ae9dca99 = (elements, watchedState)=>{
    // renderMortgageAmount
    $c373a14459b79063$var$renderMortgageAmount(elements, watchedState);
    // renderTotalCost
    $c373a14459b79063$var$renderTotalCost(elements, watchedState);
    // renderMonthlyPayment
    $c373a14459b79063$var$renderMonthlyPayment(elements, watchedState);
    // renderDonutChart
    $c373a14459b79063$var$renderDonutChart(elements, watchedState);
};
const $c373a14459b79063$export$659466fae8e0b94d = (elements, value)=>{
    const { switchPmiBlock: switchPmiBlock  } = elements;
    if (value) switchPmiBlock.forEach((item)=>item.style.display = "none");
    else switchPmiBlock.forEach((item)=>item.style.display = "block");
};
const $c373a14459b79063$export$9c7c917e2ae392f5 = (elements, value)=>{
    const { switchTaxesBlock: switchTaxesBlock  } = elements;
    if (value) switchTaxesBlock.forEach((item)=>{
        const itemResult = item;
        itemResult.style.display = "none";
    });
    else switchTaxesBlock.forEach((item)=>{
        const itemResult = item;
        itemResult.style.display = "block";
    });
};
const $c373a14459b79063$export$2837078cde969e9f = (elements, watchedState)=>{
    const { donutLegendItems: donutLegendItems  } = elements;
    const { donutData: donutData  } = watchedState;
    donutLegendItems.forEach((item)=>{
        donutData.forEach(({ name: name , color: color  }, index)=>{
            if (item.getAttribute("data-calc-legend-name") === donutData[index].name) item.style.backgroundColor = donutData[index].color;
        });
    });
};


// controller
// watch exclude changes
const $81003cf77206408e$var$updateExclude = (form, watchedState)=>{
    const excludesElements = form.querySelectorAll("[data-calc-exclude]");
    const { exclude: exclude  } = watchedState.form;
    [
        ...excludesElements
    ].forEach((excludeItem)=>{
        const { checked: checked  } = excludeItem;
        const { calcExclude: calcExclude  } = excludeItem.dataset;
        const calcExcludeCollection = calcExclude.split(",");
        calcExcludeCollection.forEach((name)=>{
            exclude[name] = !checked;
        });
    });
};
const $81003cf77206408e$var$updateValues = (elements, watchedState)=>{
    const { values: values  } = watchedState.form;
    const { form: form  } = elements;
    const formData = new FormData(form);
    // update values
    [
        ...formData.entries()
    ].forEach(([key, value])=>{
        if (key in values) values[key] = value === "" ? 0 : +value;
    });
    // update exclude list
    $81003cf77206408e$var$updateExclude(form, watchedState);
};
const $81003cf77206408e$var$init = ()=>{
    // MODEL
    const elements = {
        form: document.forms.calc,
        resultMortgageAmount: document.querySelector('[data-calc-result="amount"]'),
        resultTotalCost: document.querySelector('[data-calc-result="total"]'),
        resultMonthlyPayment: document.querySelector('[data-calc-result="monthly"]'),
        switchPmiBlock: document.querySelectorAll("[data-pmi-rate]"),
        switchTaxesBlock: document.querySelectorAll("[data-property-tax]"),
        // for donut
        donutBox: document.querySelector('[data-calc="donut"]'),
        donutLegendItems: document.querySelectorAll("[data-calc-legend-name]")
    };
    // MODEL
    const state = {
        form: {
            values: {
                "home-price": null,
                "down-payment": null,
                "interest-rate": null,
                "home-insurance": null,
                "property-tax": null,
                "pmi-rate": null,
                "hoa-dues": null,
                term: null
            },
            exclude: {
                "home-insurance": null,
                "pmi-rate": null,
                "property-tax": null
            }
        },
        result: {
            "mortgage-amount": null,
            "monthly-payment": null,
            "mortgage-insurance": null,
            "mortgage-total-cost": null
        },
        donutData: [
            {
                key: "pi",
                name: "P&I",
                color: "#0D93FF",
                data: null
            },
            {
                key: "insurance",
                name: "Insurance",
                color: "#07BECB",
                data: null
            },
            {
                key: "taxes",
                name: "Taxes",
                color: "#333333",
                data: null
            },
            {
                key: "pmi",
                name: "PMI",
                color: "#D3E2EE",
                data: null
            },
            {
                key: "hoa",
                name: "HOA",
                color: "#F2F2F2",
                data: null
            }, 
        ]
    };
    // MODEL
    const watchedState = (0, $69e9f2982bc0ecad$export$2e2bcd8739ae039)(state, (path, value)=>{
        switch(path){
            case "form.exclude.pmi-rate":
                (0, $c373a14459b79063$export$659466fae8e0b94d)(elements, value);
                break;
            case "form.exclude.property-tax":
                (0, $c373a14459b79063$export$9c7c917e2ae392f5)(elements, value);
                break;
            default:
                break;
        }
        (0, $d51973068a97db52$export$2e2bcd8739ae039)(elements, watchedState);
    });
    // CONTROLLER
    const { form: form  } = elements;
    form.addEventListener("submit", (e)=>{
        e.preventDefault();
        (0, $c373a14459b79063$export$b3890eb0ae9dca99)(elements, watchedState);
    });
    form.addEventListener("change", ()=>{
        $81003cf77206408e$var$updateValues(elements, watchedState);
        (0, $c373a14459b79063$export$b3890eb0ae9dca99)(elements, watchedState);
    });
    // FIRST START
    $81003cf77206408e$var$updateValues(elements, watchedState);
    (0, $c373a14459b79063$export$b3890eb0ae9dca99)(elements, watchedState);
    (0, $c373a14459b79063$export$2837078cde969e9f)(elements, watchedState);
};
$81003cf77206408e$var$init();


